(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["polyfills"], {
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-function.js": 
        /*!*************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-function.js ***!
          \*************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = function (it) {
                if (typeof it != 'function') {
                    throw TypeError(String(it) + ' is not a function');
                }
                return it;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-possible-prototype.js": 
        /*!***********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-possible-prototype.js ***!
          \***********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            module.exports = function (it) {
                if (!isObject(it) && it !== null) {
                    throw TypeError("Can't set " + String(it) + ' as a prototype');
                }
                return it;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-instance.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-instance.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = function (it, Constructor, name) {
                if (!(it instanceof Constructor)) {
                    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
                }
                return it;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            module.exports = function (it) {
                if (!isObject(it)) {
                    throw TypeError(String(it) + ' is not an object');
                }
                return it;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-includes.js": 
        /*!*****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-includes.js ***!
          \*****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-indexed-object.js");
            var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-length.js");
            var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-absolute-index.js");
            // `Array.prototype.{ indexOf, includes }` methods implementation
            var createMethod = function (IS_INCLUDES) {
                return function ($this, el, fromIndex) {
                    var O = toIndexedObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el)
                        while (length > index) {
                            value = O[index++];
                            // eslint-disable-next-line no-self-compare
                            if (value != value)
                                return true;
                            // Array#indexOf ignores holes, Array#includes - not
                        }
                    else
                        for (; length > index; index++) {
                            if ((IS_INCLUDES || index in O) && O[index] === el)
                                return IS_INCLUDES || index || 0;
                        }
                    return !IS_INCLUDES && -1;
                };
            };
            module.exports = {
                // `Array.prototype.includes` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.includes
                includes: createMethod(true),
                // `Array.prototype.indexOf` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
                indexOf: createMethod(false)
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-iteration.js": 
        /*!******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-iteration.js ***!
          \******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/bind-context.js");
            var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/indexed-object.js");
            var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-object.js");
            var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-length.js");
            var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-species-create.js");
            var push = [].push;
            // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
            var createMethod = function (TYPE) {
                var IS_MAP = TYPE == 1;
                var IS_FILTER = TYPE == 2;
                var IS_SOME = TYPE == 3;
                var IS_EVERY = TYPE == 4;
                var IS_FIND_INDEX = TYPE == 6;
                var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                return function ($this, callbackfn, that, specificCreate) {
                    var O = toObject($this);
                    var self = IndexedObject(O);
                    var boundFunction = bind(callbackfn, that, 3);
                    var length = toLength(self.length);
                    var index = 0;
                    var create = specificCreate || arraySpeciesCreate;
                    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
                    var value, result;
                    for (; length > index; index++)
                        if (NO_HOLES || index in self) {
                            value = self[index];
                            result = boundFunction(value, index, O);
                            if (TYPE) {
                                if (IS_MAP)
                                    target[index] = result; // map
                                else if (result)
                                    switch (TYPE) {
                                        case 3: return true; // some
                                        case 5: return value; // find
                                        case 6: return index; // findIndex
                                        case 2: push.call(target, value); // filter
                                    }
                                else if (IS_EVERY)
                                    return false; // every
                            }
                        }
                    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                };
            };
            module.exports = {
                // `Array.prototype.forEach` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
                forEach: createMethod(0),
                // `Array.prototype.map` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.map
                map: createMethod(1),
                // `Array.prototype.filter` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.filter
                filter: createMethod(2),
                // `Array.prototype.some` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.some
                some: createMethod(3),
                // `Array.prototype.every` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.every
                every: createMethod(4),
                // `Array.prototype.find` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.find
                find: createMethod(5),
                // `Array.prototype.findIndex` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
                findIndex: createMethod(6)
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-species-create.js": 
        /*!***********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-species-create.js ***!
          \***********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var SPECIES = wellKnownSymbol('species');
            // `ArraySpeciesCreate` abstract operation
            // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
            module.exports = function (originalArray, length) {
                var C;
                if (isArray(originalArray)) {
                    C = originalArray.constructor;
                    // cross-realm fallback
                    if (typeof C == 'function' && (C === Array || isArray(C.prototype)))
                        C = undefined;
                    else if (isObject(C)) {
                        C = C[SPECIES];
                        if (C === null)
                            C = undefined;
                    }
                }
                return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/bind-context.js": 
        /*!***************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/bind-context.js ***!
          \***************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-function.js");
            // optional / simple context binding
            module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined)
                    return fn;
                switch (length) {
                    case 0: return function () {
                        return fn.call(that);
                    };
                    case 1: return function (a) {
                        return fn.call(that, a);
                    };
                    case 2: return function (a, b) {
                        return fn.call(that, a, b);
                    };
                    case 3: return function (a, b, c) {
                        return fn.call(that, a, b, c);
                    };
                }
                return function ( /* ...args */) {
                    return fn.apply(that, arguments);
                };
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/call-with-safe-iteration-closing.js": 
        /*!***********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
          \***********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            // call something on iterator step with safe closing on error
            module.exports = function (iterator, fn, value, ENTRIES) {
                try {
                    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                    // 7.4.6 IteratorClose(iterator, completion)
                }
                catch (error) {
                    var returnMethod = iterator['return'];
                    if (returnMethod !== undefined)
                        anObject(returnMethod.call(iterator));
                    throw error;
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/check-correctness-of-iteration.js": 
        /*!*********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/check-correctness-of-iteration.js ***!
          \*********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var SAFE_CLOSING = false;
            try {
                var called = 0;
                var iteratorWithReturn = {
                    next: function () {
                        return { done: !!called++ };
                    },
                    'return': function () {
                        SAFE_CLOSING = true;
                    }
                };
                iteratorWithReturn[ITERATOR] = function () {
                    return this;
                };
                // eslint-disable-next-line no-throw-literal
                Array.from(iteratorWithReturn, function () { throw 2; });
            }
            catch (error) { /* empty */ }
            module.exports = function (exec, SKIP_CLOSING) {
                if (!SKIP_CLOSING && !SAFE_CLOSING)
                    return false;
                var ITERATION_SUPPORT = false;
                try {
                    var object = {};
                    object[ITERATOR] = function () {
                        return {
                            next: function () {
                                return { done: ITERATION_SUPPORT = true };
                            }
                        };
                    };
                    exec(object);
                }
                catch (error) { /* empty */ }
                return ITERATION_SUPPORT;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof-raw.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof-raw.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            var toString = {}.toString;
            module.exports = function (it) {
                return toString.call(it).slice(8, -1);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof.js": 
        /*!**********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof.js ***!
          \**********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof-raw.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var TO_STRING_TAG = wellKnownSymbol('toStringTag');
            // ES3 wrong here
            var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
            // fallback for IE11 Script Access Denied error
            var tryGet = function (it, key) {
                try {
                    return it[key];
                }
                catch (error) { /* empty */ }
            };
            // getting tag from ES6+ `Object.prototype.toString`
            module.exports = function (it) {
                var O, tag, result;
                return it === undefined ? 'Undefined' : it === null ? 'Null'
                    // @@toStringTag case
                    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
                        // builtinTag case
                        : CORRECT_ARGUMENTS ? classofRaw(O)
                            // ES3 arguments fallback
                            : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-strong.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-strong.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js").f;
            var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-create.js");
            var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine-all.js");
            var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/bind-context.js");
            var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-instance.js");
            var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js");
            var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/define-iterator.js");
            var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-species.js");
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var fastKey = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js").fastKey;
            var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js");
            var setInternalState = InternalStateModule.set;
            var internalStateGetterFor = InternalStateModule.getterFor;
            module.exports = {
                getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
                    var C = wrapper(function (that, iterable) {
                        anInstance(that, C, CONSTRUCTOR_NAME);
                        setInternalState(that, {
                            type: CONSTRUCTOR_NAME,
                            index: create(null),
                            first: undefined,
                            last: undefined,
                            size: 0
                        });
                        if (!DESCRIPTORS)
                            that.size = 0;
                        if (iterable != undefined)
                            iterate(iterable, that[ADDER], that, IS_MAP);
                    });
                    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
                    var define = function (that, key, value) {
                        var state = getInternalState(that);
                        var entry = getEntry(that, key);
                        var previous, index;
                        // change existing entry
                        if (entry) {
                            entry.value = value;
                            // create new entry
                        }
                        else {
                            state.last = entry = {
                                index: index = fastKey(key, true),
                                key: key,
                                value: value,
                                previous: previous = state.last,
                                next: undefined,
                                removed: false
                            };
                            if (!state.first)
                                state.first = entry;
                            if (previous)
                                previous.next = entry;
                            if (DESCRIPTORS)
                                state.size++;
                            else
                                that.size++;
                            // add to index
                            if (index !== 'F')
                                state.index[index] = entry;
                        }
                        return that;
                    };
                    var getEntry = function (that, key) {
                        var state = getInternalState(that);
                        // fast case
                        var index = fastKey(key);
                        var entry;
                        if (index !== 'F')
                            return state.index[index];
                        // frozen object case
                        for (entry = state.first; entry; entry = entry.next) {
                            if (entry.key == key)
                                return entry;
                        }
                    };
                    redefineAll(C.prototype, {
                        // 23.1.3.1 Map.prototype.clear()
                        // 23.2.3.2 Set.prototype.clear()
                        clear: function clear() {
                            var that = this;
                            var state = getInternalState(that);
                            var data = state.index;
                            var entry = state.first;
                            while (entry) {
                                entry.removed = true;
                                if (entry.previous)
                                    entry.previous = entry.previous.next = undefined;
                                delete data[entry.index];
                                entry = entry.next;
                            }
                            state.first = state.last = undefined;
                            if (DESCRIPTORS)
                                state.size = 0;
                            else
                                that.size = 0;
                        },
                        // 23.1.3.3 Map.prototype.delete(key)
                        // 23.2.3.4 Set.prototype.delete(value)
                        'delete': function (key) {
                            var that = this;
                            var state = getInternalState(that);
                            var entry = getEntry(that, key);
                            if (entry) {
                                var next = entry.next;
                                var prev = entry.previous;
                                delete state.index[entry.index];
                                entry.removed = true;
                                if (prev)
                                    prev.next = next;
                                if (next)
                                    next.previous = prev;
                                if (state.first == entry)
                                    state.first = next;
                                if (state.last == entry)
                                    state.last = prev;
                                if (DESCRIPTORS)
                                    state.size--;
                                else
                                    that.size--;
                            }
                            return !!entry;
                        },
                        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                        forEach: function forEach(callbackfn /* , that = undefined */) {
                            var state = getInternalState(this);
                            var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                            var entry;
                            while (entry = entry ? entry.next : state.first) {
                                boundFunction(entry.value, entry.key, this);
                                // revert to the last existing entry
                                while (entry && entry.removed)
                                    entry = entry.previous;
                            }
                        },
                        // 23.1.3.7 Map.prototype.has(key)
                        // 23.2.3.7 Set.prototype.has(value)
                        has: function has(key) {
                            return !!getEntry(this, key);
                        }
                    });
                    redefineAll(C.prototype, IS_MAP ? {
                        // 23.1.3.6 Map.prototype.get(key)
                        get: function get(key) {
                            var entry = getEntry(this, key);
                            return entry && entry.value;
                        },
                        // 23.1.3.9 Map.prototype.set(key, value)
                        set: function set(key, value) {
                            return define(this, key === 0 ? 0 : key, value);
                        }
                    } : {
                        // 23.2.3.1 Set.prototype.add(value)
                        add: function add(value) {
                            return define(this, value = value === 0 ? 0 : value, value);
                        }
                    });
                    if (DESCRIPTORS)
                        defineProperty(C.prototype, 'size', {
                            get: function () {
                                return getInternalState(this).size;
                            }
                        });
                    return C;
                },
                setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
                    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
                    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
                    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
                    // add .keys, .values, .entries, [@@iterator]
                    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
                    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
                        setInternalState(this, {
                            type: ITERATOR_NAME,
                            target: iterated,
                            state: getInternalCollectionState(iterated),
                            kind: kind,
                            last: undefined
                        });
                    }, function () {
                        var state = getInternalIteratorState(this);
                        var kind = state.kind;
                        var entry = state.last;
                        // revert to the last existing entry
                        while (entry && entry.removed)
                            entry = entry.previous;
                        // get next entry
                        if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                            // or finish the iteration
                            state.target = undefined;
                            return { value: undefined, done: true };
                        }
                        // return step by kind
                        if (kind == 'keys')
                            return { value: entry.key, done: false };
                        if (kind == 'values')
                            return { value: entry.value, done: false };
                        return { value: [entry.key, entry.value], done: false };
                    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
                    // add [@@species], 23.1.2.2, 23.2.2.2
                    setSpecies(CONSTRUCTOR_NAME);
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-weak.js": 
        /*!******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-weak.js ***!
          \******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine-all.js");
            var getWeakData = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js").getWeakData;
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-instance.js");
            var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js");
            var ArrayIterationModule = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-iteration.js");
            var $has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js");
            var setInternalState = InternalStateModule.set;
            var internalStateGetterFor = InternalStateModule.getterFor;
            var find = ArrayIterationModule.find;
            var findIndex = ArrayIterationModule.findIndex;
            var id = 0;
            // fallback for uncaught frozen keys
            var uncaughtFrozenStore = function (store) {
                return store.frozen || (store.frozen = new UncaughtFrozenStore());
            };
            var UncaughtFrozenStore = function () {
                this.entries = [];
            };
            var findUncaughtFrozen = function (store, key) {
                return find(store.entries, function (it) {
                    return it[0] === key;
                });
            };
            UncaughtFrozenStore.prototype = {
                get: function (key) {
                    var entry = findUncaughtFrozen(this, key);
                    if (entry)
                        return entry[1];
                },
                has: function (key) {
                    return !!findUncaughtFrozen(this, key);
                },
                set: function (key, value) {
                    var entry = findUncaughtFrozen(this, key);
                    if (entry)
                        entry[1] = value;
                    else
                        this.entries.push([key, value]);
                },
                'delete': function (key) {
                    var index = findIndex(this.entries, function (it) {
                        return it[0] === key;
                    });
                    if (~index)
                        this.entries.splice(index, 1);
                    return !!~index;
                }
            };
            module.exports = {
                getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
                    var C = wrapper(function (that, iterable) {
                        anInstance(that, C, CONSTRUCTOR_NAME);
                        setInternalState(that, {
                            type: CONSTRUCTOR_NAME,
                            id: id++,
                            frozen: undefined
                        });
                        if (iterable != undefined)
                            iterate(iterable, that[ADDER], that, IS_MAP);
                    });
                    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
                    var define = function (that, key, value) {
                        var state = getInternalState(that);
                        var data = getWeakData(anObject(key), true);
                        if (data === true)
                            uncaughtFrozenStore(state).set(key, value);
                        else
                            data[state.id] = value;
                        return that;
                    };
                    redefineAll(C.prototype, {
                        // 23.3.3.2 WeakMap.prototype.delete(key)
                        // 23.4.3.3 WeakSet.prototype.delete(value)
                        'delete': function (key) {
                            var state = getInternalState(this);
                            if (!isObject(key))
                                return false;
                            var data = getWeakData(key);
                            if (data === true)
                                return uncaughtFrozenStore(state)['delete'](key);
                            return data && $has(data, state.id) && delete data[state.id];
                        },
                        // 23.3.3.4 WeakMap.prototype.has(key)
                        // 23.4.3.4 WeakSet.prototype.has(value)
                        has: function has(key) {
                            var state = getInternalState(this);
                            if (!isObject(key))
                                return false;
                            var data = getWeakData(key);
                            if (data === true)
                                return uncaughtFrozenStore(state).has(key);
                            return data && $has(data, state.id);
                        }
                    });
                    redefineAll(C.prototype, IS_MAP ? {
                        // 23.3.3.3 WeakMap.prototype.get(key)
                        get: function get(key) {
                            var state = getInternalState(this);
                            if (isObject(key)) {
                                var data = getWeakData(key);
                                if (data === true)
                                    return uncaughtFrozenStore(state).get(key);
                                return data ? data[state.id] : undefined;
                            }
                        },
                        // 23.3.3.5 WeakMap.prototype.set(key, value)
                        set: function set(key, value) {
                            return define(this, key, value);
                        }
                    } : {
                        // 23.4.3.1 WeakSet.prototype.add(value)
                        add: function add(value) {
                            return define(this, value, true);
                        }
                    });
                    return C;
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection.js": 
        /*!*************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection.js ***!
          \*************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-forced.js");
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js");
            var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js");
            var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js");
            var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-instance.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/check-correctness-of-iteration.js");
            var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-to-string-tag.js");
            var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/inherit-if-required.js");
            module.exports = function (CONSTRUCTOR_NAME, wrapper, common, IS_MAP, IS_WEAK) {
                var NativeConstructor = global[CONSTRUCTOR_NAME];
                var NativePrototype = NativeConstructor && NativeConstructor.prototype;
                var Constructor = NativeConstructor;
                var ADDER = IS_MAP ? 'set' : 'add';
                var exported = {};
                var fixMethod = function (KEY) {
                    var nativeMethod = NativePrototype[KEY];
                    redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
                        nativeMethod.call(this, value === 0 ? 0 : value);
                        return this;
                    } : KEY == 'delete' ? function (key) {
                        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
                    } : KEY == 'get' ? function get(key) {
                        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
                    } : KEY == 'has' ? function has(key) {
                        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
                    } : function set(key, value) {
                        nativeMethod.call(this, key === 0 ? 0 : key, value);
                        return this;
                    });
                };
                // eslint-disable-next-line max-len
                if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
                    new NativeConstructor().entries().next();
                })))) {
                    // create collection constructor
                    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
                    InternalMetadataModule.REQUIRED = true;
                }
                else if (isForced(CONSTRUCTOR_NAME, true)) {
                    var instance = new Constructor();
                    // early implementations not supports chaining
                    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
                    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
                    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
                    // most early implementations doesn't supports iterables, most modern - not close it correctly
                    // eslint-disable-next-line no-new
                    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
                    // for early implementations -0 and +0 not the same
                    var BUGGY_ZERO = !IS_WEAK && fails(function () {
                        // V8 ~ Chromium 42- fails only with 5+ elements
                        var $instance = new NativeConstructor();
                        var index = 5;
                        while (index--)
                            $instance[ADDER](index, index);
                        return !$instance.has(-0);
                    });
                    if (!ACCEPT_ITERABLES) {
                        Constructor = wrapper(function (dummy, iterable) {
                            anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
                            var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                            if (iterable != undefined)
                                iterate(iterable, that[ADDER], that, IS_MAP);
                            return that;
                        });
                        Constructor.prototype = NativePrototype;
                        NativePrototype.constructor = Constructor;
                    }
                    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                        fixMethod('delete');
                        fixMethod('has');
                        IS_MAP && fixMethod('get');
                    }
                    if (BUGGY_ZERO || HASNT_CHAINING)
                        fixMethod(ADDER);
                    // weak collections should not contains .clear method
                    if (IS_WEAK && NativePrototype.clear)
                        delete NativePrototype.clear;
                }
                exported[CONSTRUCTOR_NAME] = Constructor;
                $({ global: true, forced: Constructor != NativeConstructor }, exported);
                setToStringTag(Constructor, CONSTRUCTOR_NAME);
                if (!IS_WEAK)
                    common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
                return Constructor;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/copy-constructor-properties.js": 
        /*!******************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/copy-constructor-properties.js ***!
          \******************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/own-keys.js");
            var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-descriptor.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js");
            module.exports = function (target, source) {
                var keys = ownKeys(source);
                var defineProperty = definePropertyModule.f;
                var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if (!has(target, key))
                        defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/correct-prototype-getter.js": 
        /*!***************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/correct-prototype-getter.js ***!
          \***************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            module.exports = !fails(function () {
                function F() { }
                F.prototype.constructor = null;
                return Object.getPrototypeOf(new F()) !== F.prototype;
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-iterator-constructor.js": 
        /*!******************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-iterator-constructor.js ***!
          \******************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
            var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-create.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-property-descriptor.js");
            var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-to-string-tag.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js");
            var returnThis = function () { return this; };
            module.exports = function (IteratorConstructor, NAME, next) {
                var TO_STRING_TAG = NAME + ' Iterator';
                IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
                setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                Iterators[TO_STRING_TAG] = returnThis;
                return IteratorConstructor;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-property-descriptor.js": 
        /*!*****************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-property-descriptor.js ***!
          \*****************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = function (bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/define-iterator.js": 
        /*!******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/define-iterator.js ***!
          \******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-iterator-constructor.js");
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js");
            var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-set-prototype-of.js");
            var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-to-string-tag.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-pure.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js");
            var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators-core.js");
            var IteratorPrototype = IteratorsCore.IteratorPrototype;
            var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
            var ITERATOR = wellKnownSymbol('iterator');
            var KEYS = 'keys';
            var VALUES = 'values';
            var ENTRIES = 'entries';
            var returnThis = function () { return this; };
            module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                createIteratorConstructor(IteratorConstructor, NAME, next);
                var getIterationMethod = function (KIND) {
                    if (KIND === DEFAULT && defaultIterator)
                        return defaultIterator;
                    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
                        return IterablePrototype[KIND];
                    switch (KIND) {
                        case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
                        case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
                        case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
                    }
                    return function () { return new IteratorConstructor(this); };
                };
                var TO_STRING_TAG = NAME + ' Iterator';
                var INCORRECT_VALUES_NAME = false;
                var IterablePrototype = Iterable.prototype;
                var nativeIterator = IterablePrototype[ITERATOR]
                    || IterablePrototype['@@iterator']
                    || DEFAULT && IterablePrototype[DEFAULT];
                var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                var CurrentIteratorPrototype, methods, KEY;
                // fix native
                if (anyNativeIterator) {
                    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                        if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                            if (setPrototypeOf) {
                                setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                            }
                            else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
                                hide(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                        }
                        // Set @@toStringTag to native iterators
                        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                        if (IS_PURE)
                            Iterators[TO_STRING_TAG] = returnThis;
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() { return nativeIterator.call(this); };
                }
                // define iterator
                if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
                    hide(IterablePrototype, ITERATOR, defaultIterator);
                }
                Iterators[NAME] = defaultIterator;
                // export additional methods
                if (DEFAULT) {
                    methods = {
                        values: getIterationMethod(VALUES),
                        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                        entries: getIterationMethod(ENTRIES)
                    };
                    if (FORCED)
                        for (KEY in methods) {
                            if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                                redefine(IterablePrototype, KEY, methods[KEY]);
                            }
                        }
                    else
                        $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
                }
                return methods;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            // Thank's IE8 for his funny defineProperty
            module.exports = !fails(function () {
                return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/document-create-element.js": 
        /*!**************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/document-create-element.js ***!
          \**************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var document = global.document;
            // typeof document.createElement is 'object' in old IE
            var EXISTS = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
                return EXISTS ? document.createElement(it) : {};
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/enum-bug-keys.js": 
        /*!****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/enum-bug-keys.js ***!
          \****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            // IE8- don't enum bug keys
            module.exports = [
                'constructor',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'toLocaleString',
                'toString',
                'valueOf'
            ];
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js": 
        /*!*********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js ***!
          \*********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-global.js");
            var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/copy-constructor-properties.js");
            var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-forced.js");
            /*
              options.target      - name of the target object
              options.global      - target is the global object
              options.stat        - export as static methods of target
              options.proto       - export as prototype methods of target
              options.real        - real prototype method for the `pure` version
              options.forced      - export even if the native feature is available
              options.bind        - bind methods to the target, required for the `pure` version
              options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
              options.unsafe      - use the simple assignment of property instead of delete + defineProperty
              options.sham        - add a flag to not completely full polyfills
              options.enumerable  - export as enumerable property
              options.noTargetGet - prevent calling a getter on target
            */
            module.exports = function (options, source) {
                var TARGET = options.target;
                var GLOBAL = options.global;
                var STATIC = options.stat;
                var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                if (GLOBAL) {
                    target = global;
                }
                else if (STATIC) {
                    target = global[TARGET] || setGlobal(TARGET, {});
                }
                else {
                    target = (global[TARGET] || {}).prototype;
                }
                if (target)
                    for (key in source) {
                        sourceProperty = source[key];
                        if (options.noTargetGet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        }
                        else
                            targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                        // contained in target
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty === typeof targetProperty)
                                continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        // add a flag to not completely full polyfills
                        if (options.sham || (targetProperty && targetProperty.sham)) {
                            hide(sourceProperty, 'sham', true);
                        }
                        // extend global
                        redefine(target, key, sourceProperty, options);
                    }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js": 
        /*!********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js ***!
          \********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = function (exec) {
                try {
                    return !!exec();
                }
                catch (error) {
                    return true;
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/freezing.js": 
        /*!***********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/freezing.js ***!
          \***********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            module.exports = !fails(function () {
                return Object.isExtensible(Object.preventExtensions({}));
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/function-to-string.js": 
        /*!*********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/function-to-string.js ***!
          \*********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js");
            module.exports = shared('native-function-to-string', Function.toString);
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-built-in.js": 
        /*!***************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-built-in.js ***!
          \***************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var path = __webpack_require__(/*! ../internals/path */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/path.js");
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var aFunction = function (variable) {
                return typeof variable == 'function' ? variable : undefined;
            };
            module.exports = function (namespace, method) {
                return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
                    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-iterator-method.js": 
        /*!**********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-iterator-method.js ***!
          \**********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var ITERATOR = wellKnownSymbol('iterator');
            module.exports = function (it) {
                if (it != undefined)
                    return it[ITERATOR]
                        || it['@@iterator']
                        || Iterators[classof(it)];
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js": 
        /*!*********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js ***!
          \*********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            var O = 'object';
            var check = function (it) {
                return it && it.Math == Math && it;
            };
            // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            module.exports =
                // eslint-disable-next-line no-undef
                check(typeof globalThis == O && globalThis) ||
                    check(typeof window == O && window) ||
                    check(typeof self == O && self) ||
                    check(typeof global == O && global) ||
                    // eslint-disable-next-line no-new-func
                    Function('return this')();
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js": 
        /*!******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js ***!
          \******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = {};
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js": 
        /*!*******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js ***!
          \*******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-property-descriptor.js");
            module.exports = DESCRIPTORS ? function (object, key, value) {
                return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
            } : function (object, key, value) {
                object[key] = value;
                return object;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/html.js": 
        /*!*******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/html.js ***!
          \*******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-built-in.js");
            module.exports = getBuiltIn('document', 'documentElement');
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/ie8-dom-define.js": 
        /*!*****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/ie8-dom-define.js ***!
          \*****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/document-create-element.js");
            // Thank's IE8 for his funny defineProperty
            module.exports = !DESCRIPTORS && !fails(function () {
                return Object.defineProperty(createElement('div'), 'a', {
                    get: function () { return 7; }
                }).a != 7;
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/indexed-object.js": 
        /*!*****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/indexed-object.js ***!
          \*****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof-raw.js");
            var split = ''.split;
            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            module.exports = fails(function () {
                // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                // eslint-disable-next-line no-prototype-builtins
                return !Object('z').propertyIsEnumerable(0);
            }) ? function (it) {
                return classof(it) == 'String' ? split.call(it, '') : Object(it);
            } : Object;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/inherit-if-required.js": 
        /*!**********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/inherit-if-required.js ***!
          \**********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-set-prototype-of.js");
            // makes subclassing work correct for wrapped built-ins
            module.exports = function ($this, dummy, Wrapper) {
                var NewTarget, NewTargetPrototype;
                if (
                // it can work only with native `setPrototypeOf`
                setPrototypeOf &&
                    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
                    typeof (NewTarget = dummy.constructor) == 'function' &&
                    NewTarget !== Wrapper &&
                    isObject(NewTargetPrototype = NewTarget.prototype) &&
                    NewTargetPrototype !== Wrapper.prototype)
                    setPrototypeOf($this, NewTargetPrototype);
                return $this;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js").f;
            var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/uid.js");
            var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/freezing.js");
            var METADATA = uid('meta');
            var id = 0;
            var isExtensible = Object.isExtensible || function () {
                return true;
            };
            var setMetadata = function (it) {
                defineProperty(it, METADATA, { value: {
                        objectID: 'O' + ++id,
                        weakData: {} // weak collections IDs
                    } });
            };
            var fastKey = function (it, create) {
                // return a primitive with prefix
                if (!isObject(it))
                    return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, METADATA)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it))
                        return 'F';
                    // not necessary to add metadata
                    if (!create)
                        return 'E';
                    // add missing metadata
                    setMetadata(it);
                    // return object ID
                }
                return it[METADATA].objectID;
            };
            var getWeakData = function (it, create) {
                if (!has(it, METADATA)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it))
                        return true;
                    // not necessary to add metadata
                    if (!create)
                        return false;
                    // add missing metadata
                    setMetadata(it);
                    // return the store of weak collections IDs
                }
                return it[METADATA].weakData;
            };
            // add metadata on freeze-family methods calling
            var onFreeze = function (it) {
                if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA))
                    setMetadata(it);
                return it;
            };
            var meta = module.exports = {
                REQUIRED: false,
                fastKey: fastKey,
                getWeakData: getWeakData,
                onFreeze: onFreeze
            };
            hiddenKeys[METADATA] = true;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js": 
        /*!*****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js ***!
          \*****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-weak-map.js");
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared-key.js");
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js");
            var WeakMap = global.WeakMap;
            var set, get, has;
            var enforce = function (it) {
                return has(it) ? get(it) : set(it, {});
            };
            var getterFor = function (TYPE) {
                return function (it) {
                    var state;
                    if (!isObject(it) || (state = get(it)).type !== TYPE) {
                        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
                    }
                    return state;
                };
            };
            if (NATIVE_WEAK_MAP) {
                var store = new WeakMap();
                var wmget = store.get;
                var wmhas = store.has;
                var wmset = store.set;
                set = function (it, metadata) {
                    wmset.call(store, it, metadata);
                    return metadata;
                };
                get = function (it) {
                    return wmget.call(store, it) || {};
                };
                has = function (it) {
                    return wmhas.call(store, it);
                };
            }
            else {
                var STATE = sharedKey('state');
                hiddenKeys[STATE] = true;
                set = function (it, metadata) {
                    hide(it, STATE, metadata);
                    return metadata;
                };
                get = function (it) {
                    return objectHas(it, STATE) ? it[STATE] : {};
                };
                has = function (it) {
                    return objectHas(it, STATE);
                };
            }
            module.exports = {
                set: set,
                get: get,
                has: has,
                enforce: enforce,
                getterFor: getterFor
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array-iterator-method.js": 
        /*!***************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array-iterator-method.js ***!
          \***************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var ArrayPrototype = Array.prototype;
            // check on default Array iterator
            module.exports = function (it) {
                return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array.js": 
        /*!***********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array.js ***!
          \***********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/classof-raw.js");
            // `IsArray` abstract operation
            // https://tc39.github.io/ecma262/#sec-isarray
            module.exports = Array.isArray || function isArray(arg) {
                return classof(arg) == 'Array';
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-forced.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-forced.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            var replacement = /#|\.prototype\./;
            var isForced = function (feature, detection) {
                var value = data[normalize(feature)];
                return value == POLYFILL ? true
                    : value == NATIVE ? false
                        : typeof detection == 'function' ? fails(detection)
                            : !!detection;
            };
            var normalize = isForced.normalize = function (string) {
                return String(string).replace(replacement, '.').toLowerCase();
            };
            var data = isForced.data = {};
            var NATIVE = isForced.NATIVE = 'N';
            var POLYFILL = isForced.POLYFILL = 'P';
            module.exports = isForced;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = function (it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-pure.js": 
        /*!**********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-pure.js ***!
          \**********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = false;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js": 
        /*!**********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js ***!
          \**********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-array-iterator-method.js");
            var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-length.js");
            var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/bind-context.js");
            var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-iterator-method.js");
            var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/call-with-safe-iteration-closing.js");
            var Result = function (stopped, result) {
                this.stopped = stopped;
                this.result = result;
            };
            var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
                var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
                var iterator, iterFn, index, length, result, step;
                if (IS_ITERATOR) {
                    iterator = iterable;
                }
                else {
                    iterFn = getIteratorMethod(iterable);
                    if (typeof iterFn != 'function')
                        throw TypeError('Target is not iterable');
                    // optimisation for array iterators
                    if (isArrayIteratorMethod(iterFn)) {
                        for (index = 0, length = toLength(iterable.length); length > index; index++) {
                            result = AS_ENTRIES
                                ? boundFunction(anObject(step = iterable[index])[0], step[1])
                                : boundFunction(iterable[index]);
                            if (result && result instanceof Result)
                                return result;
                        }
                        return new Result(false);
                    }
                    iterator = iterFn.call(iterable);
                }
                while (!(step = iterator.next()).done) {
                    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
                    if (result && result instanceof Result)
                        return result;
                }
                return new Result(false);
            };
            iterate.stop = function (result) {
                return new Result(true, result);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators-core.js": 
        /*!*****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators-core.js ***!
          \*****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-pure.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var BUGGY_SAFARI_ITERATORS = false;
            var returnThis = function () { return this; };
            // `%IteratorPrototype%` object
            // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
            var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
            if ([].keys) {
                arrayIterator = [].keys();
                // Safari 8 has buggy iterators w/o `next`
                if (!('next' in arrayIterator))
                    BUGGY_SAFARI_ITERATORS = true;
                else {
                    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
                        IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                }
            }
            if (IteratorPrototype == undefined)
                IteratorPrototype = {};
            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            if (!IS_PURE && !has(IteratorPrototype, ITERATOR))
                hide(IteratorPrototype, ITERATOR, returnThis);
            module.exports = {
                IteratorPrototype: IteratorPrototype,
                BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterators.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            module.exports = {};
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-symbol.js": 
        /*!****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-symbol.js ***!
          \****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/fails.js");
            module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
                // Chrome 38 Symbol has incorrect toString conversion
                // eslint-disable-next-line no-undef
                return !String(Symbol());
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-weak-map.js": 
        /*!******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-weak-map.js ***!
          \******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/function-to-string.js");
            var WeakMap = global.WeakMap;
            module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-create.js": 
        /*!****************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-create.js ***!
          \****************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-properties.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/enum-bug-keys.js");
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js");
            var html = __webpack_require__(/*! ../internals/html */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/html.js");
            var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/document-create-element.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared-key.js");
            var IE_PROTO = sharedKey('IE_PROTO');
            var PROTOTYPE = 'prototype';
            var Empty = function () { };
            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function () {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = documentCreateElement('iframe');
                var length = enumBugKeys.length;
                var lt = '<';
                var script = 'script';
                var gt = '>';
                var js = 'java' + script + ':';
                var iframeDocument;
                iframe.style.display = 'none';
                html.appendChild(iframe);
                iframe.src = String(js);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while (length--)
                    delete createDict[PROTOTYPE][enumBugKeys[length]];
                return createDict();
            };
            // `Object.create` method
            // https://tc39.github.io/ecma262/#sec-object.create
            module.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                }
                else
                    result = createDict();
                return Properties === undefined ? result : defineProperties(result, Properties);
            };
            hiddenKeys[IE_PROTO] = true;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-properties.js": 
        /*!***************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-properties.js ***!
          \***************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys.js");
            // `Object.defineProperties` method
            // https://tc39.github.io/ecma262/#sec-object.defineproperties
            module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = objectKeys(Properties);
                var length = keys.length;
                var index = 0;
                var key;
                while (length > index)
                    definePropertyModule.f(O, key = keys[index++], Properties[key]);
                return O;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js": 
        /*!*************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js ***!
          \*************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/ie8-dom-define.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-primitive.js");
            var nativeDefineProperty = Object.defineProperty;
            // `Object.defineProperty` method
            // https://tc39.github.io/ecma262/#sec-object.defineproperty
            exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE)
                    try {
                        return nativeDefineProperty(O, P, Attributes);
                    }
                    catch (error) { /* empty */ }
                if ('get' in Attributes || 'set' in Attributes)
                    throw TypeError('Accessors not supported');
                if ('value' in Attributes)
                    O[P] = Attributes.value;
                return O;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-descriptor.js": 
        /*!*************************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
          \*************************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-property-is-enumerable.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/create-property-descriptor.js");
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-indexed-object.js");
            var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-primitive.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/ie8-dom-define.js");
            var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            // `Object.getOwnPropertyDescriptor` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
            exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                O = toIndexedObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE)
                    try {
                        return nativeGetOwnPropertyDescriptor(O, P);
                    }
                    catch (error) { /* empty */ }
                if (has(O, P))
                    return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-names.js": 
        /*!********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-names.js ***!
          \********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys-internal.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/enum-bug-keys.js");
            var hiddenKeys = enumBugKeys.concat('length', 'prototype');
            // `Object.getOwnPropertyNames` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return internalObjectKeys(O, hiddenKeys);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-symbols.js": 
        /*!**********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-symbols.js ***!
          \**********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            exports.f = Object.getOwnPropertySymbols;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js": 
        /*!**************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js ***!
          \**************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-object.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared-key.js");
            var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/correct-prototype-getter.js");
            var IE_PROTO = sharedKey('IE_PROTO');
            var ObjectPrototype = Object.prototype;
            // `Object.getPrototypeOf` method
            // https://tc39.github.io/ecma262/#sec-object.getprototypeof
            module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
                O = toObject(O);
                if (has(O, IE_PROTO))
                    return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                    return O.constructor.prototype;
                }
                return O instanceof Object ? ObjectPrototype : null;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys-internal.js": 
        /*!***********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys-internal.js ***!
          \***********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-indexed-object.js");
            var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/array-includes.js").indexOf;
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hidden-keys.js");
            module.exports = function (object, names) {
                var O = toIndexedObject(object);
                var i = 0;
                var result = [];
                var key;
                for (key in O)
                    !has(hiddenKeys, key) && has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while (names.length > i)
                    if (has(O, key = names[i++])) {
                        ~indexOf(result, key) || result.push(key);
                    }
                return result;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-keys-internal.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/enum-bug-keys.js");
            // `Object.keys` method
            // https://tc39.github.io/ecma262/#sec-object.keys
            module.exports = Object.keys || function keys(O) {
                return internalObjectKeys(O, enumBugKeys);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-property-is-enumerable.js": 
        /*!********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-property-is-enumerable.js ***!
          \********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            // Nashorn ~ JDK8 bug
            var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
            // `Object.prototype.propertyIsEnumerable` method implementation
            // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
            exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                var descriptor = getOwnPropertyDescriptor(this, V);
                return !!descriptor && descriptor.enumerable;
            } : nativePropertyIsEnumerable;
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-set-prototype-of.js": 
        /*!**************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-set-prototype-of.js ***!
          \**************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/a-possible-prototype.js");
            // `Object.setPrototypeOf` method
            // https://tc39.github.io/ecma262/#sec-object.setprototypeof
            // Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */
            module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
                var CORRECT_SETTER = false;
                var test = {};
                var setter;
                try {
                    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
                    setter.call(test, []);
                    CORRECT_SETTER = test instanceof Array;
                }
                catch (error) { /* empty */ }
                return function setPrototypeOf(O, proto) {
                    anObject(O);
                    aPossiblePrototype(proto);
                    if (CORRECT_SETTER)
                        setter.call(O, proto);
                    else
                        O.__proto__ = proto;
                    return O;
                };
            }() : undefined);
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/own-keys.js": 
        /*!***********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/own-keys.js ***!
          \***********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-built-in.js");
            var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-names.js");
            var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-own-property-symbols.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            // all object keys, includes non-enumerable and symbols
            module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                var keys = getOwnPropertyNamesModule.f(anObject(it));
                var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/path.js": 
        /*!*******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/path.js ***!
          \*******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            module.exports = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine-all.js": 
        /*!***************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine-all.js ***!
          \***************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js");
            module.exports = function (target, src, options) {
                for (var key in src)
                    redefine(target, key, src[key], options);
                return target;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js": 
        /*!***********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine.js ***!
          \***********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-global.js");
            var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/function-to-string.js");
            var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js");
            var getInternalState = InternalStateModule.get;
            var enforceInternalState = InternalStateModule.enforce;
            var TEMPLATE = String(nativeFunctionToString).split('toString');
            shared('inspectSource', function (it) {
                return nativeFunctionToString.call(it);
            });
            (module.exports = function (O, key, value, options) {
                var unsafe = options ? !!options.unsafe : false;
                var simple = options ? !!options.enumerable : false;
                var noTargetGet = options ? !!options.noTargetGet : false;
                if (typeof value == 'function') {
                    if (typeof key == 'string' && !has(value, 'name'))
                        hide(value, 'name', key);
                    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
                }
                if (O === global) {
                    if (simple)
                        O[key] = value;
                    else
                        setGlobal(key, value);
                    return;
                }
                else if (!unsafe) {
                    delete O[key];
                }
                else if (!noTargetGet && O[key]) {
                    simple = true;
                }
                if (simple)
                    O[key] = value;
                else
                    hide(O, key, value);
                // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
            })(Function.prototype, 'toString', function toString() {
                return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js": 
        /*!*******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js ***!
          \*******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
            var Map = __webpack_require__(/*! ../modules/es.map */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.map.js");
            var WeakMap = __webpack_require__(/*! ../modules/es.weak-map */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.weak-map.js");
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js");
            var metadata = shared('metadata');
            var store = metadata.store || (metadata.store = new WeakMap());
            var getOrCreateMetadataMap = function (target, targetKey, create) {
                var targetMetadata = store.get(target);
                if (!targetMetadata) {
                    if (!create)
                        return;
                    store.set(target, targetMetadata = new Map());
                }
                var keyMetadata = targetMetadata.get(targetKey);
                if (!keyMetadata) {
                    if (!create)
                        return;
                    targetMetadata.set(targetKey, keyMetadata = new Map());
                }
                return keyMetadata;
            };
            var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
                var metadataMap = getOrCreateMetadataMap(O, P, false);
                return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
            };
            var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
                var metadataMap = getOrCreateMetadataMap(O, P, false);
                return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
            };
            var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
                getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
            };
            var ordinaryOwnMetadataKeys = function (target, targetKey) {
                var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
                var keys = [];
                if (metadataMap)
                    metadataMap.forEach(function (_, key) { keys.push(key); });
                return keys;
            };
            var toMetadataKey = function (it) {
                return it === undefined || typeof it == 'symbol' ? it : String(it);
            };
            module.exports = {
                store: store,
                getMap: getOrCreateMetadataMap,
                has: ordinaryHasOwnMetadata,
                get: ordinaryGetOwnMetadata,
                set: ordinaryDefineOwnMetadata,
                keys: ordinaryOwnMetadataKeys,
                toKey: toMetadataKey
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/require-object-coercible.js": 
        /*!***************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/require-object-coercible.js ***!
          \***************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            // `RequireObjectCoercible` abstract operation
            // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
            module.exports = function (it) {
                if (it == undefined)
                    throw TypeError("Can't call method on " + it);
                return it;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-global.js": 
        /*!*************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-global.js ***!
          \*************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/hide.js");
            module.exports = function (key, value) {
                try {
                    hide(global, key, value);
                }
                catch (error) {
                    global[key] = value;
                }
                return value;
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-species.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-species.js ***!
          \**************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/get-built-in.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/descriptors.js");
            var SPECIES = wellKnownSymbol('species');
            module.exports = function (CONSTRUCTOR_NAME) {
                var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                var defineProperty = definePropertyModule.f;
                if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
                    defineProperty(Constructor, SPECIES, {
                        configurable: true,
                        get: function () { return this; }
                    });
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-to-string-tag.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-to-string-tag.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-define-property.js").f;
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/has.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js");
            var TO_STRING_TAG = wellKnownSymbol('toStringTag');
            module.exports = function (it, TAG, STATIC) {
                if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
                    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
                }
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared-key.js": 
        /*!*************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared-key.js ***!
          \*************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js");
            var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/uid.js");
            var keys = shared('keys');
            module.exports = function (key) {
                return keys[key] || (keys[key] = uid(key));
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js": 
        /*!*********************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js ***!
          \*********************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/set-global.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-pure.js");
            var SHARED = '__core-js_shared__';
            var store = global[SHARED] || setGlobal(SHARED, {});
            (module.exports = function (key, value) {
                return store[key] || (store[key] = value !== undefined ? value : {});
            })('versions', []).push({
                version: '3.2.1',
                mode: IS_PURE ? 'pure' : 'global',
                copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-absolute-index.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-absolute-index.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-integer.js");
            var max = Math.max;
            var min = Math.min;
            // Helper for a popular repeating case of the spec:
            // Let integer be ? ToInteger(index).
            // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
            module.exports = function (index, length) {
                var integer = toInteger(index);
                return integer < 0 ? max(integer + length, 0) : min(integer, length);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-indexed-object.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-indexed-object.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            // toObject with fallback for non-array-like ES3 strings
            var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/indexed-object.js");
            var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/require-object-coercible.js");
            module.exports = function (it) {
                return IndexedObject(requireObjectCoercible(it));
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-integer.js": 
        /*!*************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-integer.js ***!
          \*************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            var ceil = Math.ceil;
            var floor = Math.floor;
            // `ToInteger` abstract operation
            // https://tc39.github.io/ecma262/#sec-tointeger
            module.exports = function (argument) {
                return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-length.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-length.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-integer.js");
            var min = Math.min;
            // `ToLength` abstract operation
            // https://tc39.github.io/ecma262/#sec-tolength
            module.exports = function (argument) {
                return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-object.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-object.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/require-object-coercible.js");
            // `ToObject` abstract operation
            // https://tc39.github.io/ecma262/#sec-toobject
            module.exports = function (argument) {
                return Object(requireObjectCoercible(argument));
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-primitive.js": 
        /*!***************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/to-primitive.js ***!
          \***************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            // `ToPrimitive` abstract operation
            // https://tc39.github.io/ecma262/#sec-toprimitive
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module.exports = function (input, PREFERRED_STRING) {
                if (!isObject(input))
                    return input;
                var fn, val;
                if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input)))
                    return val;
                if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input)))
                    return val;
                if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input)))
                    return val;
                throw TypeError("Can't convert object to primitive value");
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/uid.js": 
        /*!******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/uid.js ***!
          \******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            var id = 0;
            var postfix = Math.random();
            module.exports = function (key) {
                return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js": 
        /*!********************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/well-known-symbol.js ***!
          \********************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/shared.js");
            var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/uid.js");
            var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-symbol.js");
            var Symbol = global.Symbol;
            var store = shared('wks');
            module.exports = function (name) {
                return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
                    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
            };
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.map.js": 
        /*!*******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.map.js ***!
          \*******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection.js");
            var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-strong.js");
            // `Map` constructor
            // https://tc39.github.io/ecma262/#sec-map-objects
            module.exports = collection('Map', function (get) {
                return function Map() { return get(this, arguments.length ? arguments[0] : undefined); };
            }, collectionStrong, true);
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.set.js": 
        /*!*******************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.set.js ***!
          \*******************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection.js");
            var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-strong.js");
            // `Set` constructor
            // https://tc39.github.io/ecma262/#sec-set-objects
            module.exports = collection('Set', function (get) {
                return function Set() { return get(this, arguments.length ? arguments[0] : undefined); };
            }, collectionStrong);
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.weak-map.js": 
        /*!************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.weak-map.js ***!
          \************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/global.js");
            var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/redefine-all.js");
            var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-metadata.js");
            var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection.js");
            var collectionWeak = __webpack_require__(/*! ../internals/collection-weak */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/collection-weak.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/is-object.js");
            var enforceIternalState = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/internal-state.js").enforce;
            var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/native-weak-map.js");
            var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
            var isExtensible = Object.isExtensible;
            var InternalWeakMap;
            var wrapper = function (get) {
                return function WeakMap() {
                    return get(this, arguments.length ? arguments[0] : undefined);
                };
            };
            // `WeakMap` constructor
            // https://tc39.github.io/ecma262/#sec-weakmap-constructor
            var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak, true, true);
            // IE11 WeakMap frozen keys fix
            // We can't use feature detection because it crash some old IE builds
            // https://github.com/zloirock/core-js/issues/485
            if (NATIVE_WEAK_MAP && IS_IE11) {
                InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
                InternalMetadataModule.REQUIRED = true;
                var WeakMapPrototype = $WeakMap.prototype;
                var nativeDelete = WeakMapPrototype['delete'];
                var nativeHas = WeakMapPrototype.has;
                var nativeGet = WeakMapPrototype.get;
                var nativeSet = WeakMapPrototype.set;
                redefineAll(WeakMapPrototype, {
                    'delete': function (key) {
                        if (isObject(key) && !isExtensible(key)) {
                            var state = enforceIternalState(this);
                            if (!state.frozen)
                                state.frozen = new InternalWeakMap();
                            return nativeDelete.call(this, key) || state.frozen['delete'](key);
                        }
                        return nativeDelete.call(this, key);
                    },
                    has: function has(key) {
                        if (isObject(key) && !isExtensible(key)) {
                            var state = enforceIternalState(this);
                            if (!state.frozen)
                                state.frozen = new InternalWeakMap();
                            return nativeHas.call(this, key) || state.frozen.has(key);
                        }
                        return nativeHas.call(this, key);
                    },
                    get: function get(key) {
                        if (isObject(key) && !isExtensible(key)) {
                            var state = enforceIternalState(this);
                            if (!state.frozen)
                                state.frozen = new InternalWeakMap();
                            return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
                        }
                        return nativeGet.call(this, key);
                    },
                    set: function set(key, value) {
                        if (isObject(key) && !isExtensible(key)) {
                            var state = enforceIternalState(this);
                            if (!state.frozen)
                                state.frozen = new InternalWeakMap();
                            nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
                        }
                        else
                            nativeSet.call(this, key, value);
                        return this;
                    }
                });
            }
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.define-metadata.js": 
        /*!*******************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.define-metadata.js ***!
          \*******************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var toMetadataKey = ReflectMetadataModule.toKey;
            var ordinaryDefineOwnMetadata = ReflectMetadataModule.set;
            // `Reflect.defineMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */) {
                    var targetKey = arguments.length < 4 ? undefined : toMetadataKey(arguments[3]);
                    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.delete-metadata.js": 
        /*!*******************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.delete-metadata.js ***!
          \*******************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var toMetadataKey = ReflectMetadataModule.toKey;
            var getOrCreateMetadataMap = ReflectMetadataModule.getMap;
            var store = ReflectMetadataModule.store;
            // `Reflect.deleteMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
                    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
                    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
                    if (metadataMap === undefined || !metadataMap['delete'](metadataKey))
                        return false;
                    if (metadataMap.size)
                        return true;
                    var targetMetadata = store.get(target);
                    targetMetadata['delete'](targetKey);
                    return !!targetMetadata.size || store['delete'](target);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js": 
        /*!*********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js ***!
          \*********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
            var Set = __webpack_require__(/*! ../modules/es.set */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/es.set.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js");
            var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/iterate.js");
            var ordinaryOwnMetadataKeys = ReflectMetadataModule.keys;
            var toMetadataKey = ReflectMetadataModule.toKey;
            var from = function (iter) {
                var result = [];
                iterate(iter, result.push, result);
                return result;
            };
            var ordinaryMetadataKeys = function (O, P) {
                var oKeys = ordinaryOwnMetadataKeys(O, P);
                var parent = getPrototypeOf(O);
                if (parent === null)
                    return oKeys;
                var pKeys = ordinaryMetadataKeys(parent, P);
                return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
            };
            // `Reflect.getMetadataKeys` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
                    var targetKey = arguments.length < 2 ? undefined : toMetadataKey(arguments[1]);
                    return ordinaryMetadataKeys(anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata.js": 
        /*!****************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata.js ***!
          \****************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js");
            var ordinaryHasOwnMetadata = ReflectMetadataModule.has;
            var ordinaryGetOwnMetadata = ReflectMetadataModule.get;
            var toMetadataKey = ReflectMetadataModule.toKey;
            var ordinaryGetMetadata = function (MetadataKey, O, P) {
                var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
                if (hasOwn)
                    return ordinaryGetOwnMetadata(MetadataKey, O, P);
                var parent = getPrototypeOf(O);
                return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
            };
            // `Reflect.getMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
                    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
                    return ordinaryGetMetadata(metadataKey, anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js": 
        /*!*************************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js ***!
          \*************************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var ordinaryOwnMetadataKeys = ReflectMetadataModule.keys;
            var toMetadataKey = ReflectMetadataModule.toKey;
            // `Reflect.getOwnMetadataKeys` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
                    var targetKey = arguments.length < 2 ? undefined : toMetadataKey(arguments[1]);
                    return ordinaryOwnMetadataKeys(anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js": 
        /*!********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js ***!
          \********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var ordinaryGetOwnMetadata = ReflectMetadataModule.get;
            var toMetadataKey = ReflectMetadataModule.toKey;
            // `Reflect.getOwnMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
                    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
                    return ordinaryGetOwnMetadata(metadataKey, anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-metadata.js": 
        /*!****************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-metadata.js ***!
          \****************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/object-get-prototype-of.js");
            var ordinaryHasOwnMetadata = ReflectMetadataModule.has;
            var toMetadataKey = ReflectMetadataModule.toKey;
            var ordinaryHasMetadata = function (MetadataKey, O, P) {
                var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
                if (hasOwn)
                    return true;
                var parent = getPrototypeOf(O);
                return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
            };
            // `Reflect.hasMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
                    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
                    return ordinaryHasMetadata(metadataKey, anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js": 
        /*!********************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js ***!
          \********************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var ordinaryHasOwnMetadata = ReflectMetadataModule.has;
            var toMetadataKey = ReflectMetadataModule.toKey;
            // `Reflect.hasOwnMetadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
                    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
                    return ordinaryHasOwnMetadata(metadataKey, anObject(target), targetKey);
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.metadata.js": 
        /*!************************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.metadata.js ***!
          \************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/export.js");
            var ReflectMetadataModule = __webpack_require__(/*! ../internals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/reflect-metadata.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/internals/an-object.js");
            var toMetadataKey = ReflectMetadataModule.toKey;
            var ordinaryDefineOwnMetadata = ReflectMetadataModule.set;
            // `Reflect.metadata` method
            // https://github.com/rbuckton/reflect-metadata
            $({ target: 'Reflect', stat: true }, {
                metadata: function metadata(metadataKey, metadataValue) {
                    return function decorator(target, key) {
                        ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetadataKey(key));
                    };
                }
            });
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/proposals/reflect-metadata.js": 
        /*!*******************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/node_modules/core-js/proposals/reflect-metadata.js ***!
          \*******************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            __webpack_require__(/*! ../modules/esnext.reflect.define-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.define-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.delete-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.delete-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.get-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.get-metadata-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js");
            __webpack_require__(/*! ../modules/esnext.reflect.get-own-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.get-own-metadata-keys */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js");
            __webpack_require__(/*! ../modules/esnext.reflect.has-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.has-own-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js");
            __webpack_require__(/*! ../modules/esnext.reflect.metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/modules/esnext.reflect.metadata.js");
            /***/ 
        }),
        /***/ "./node_modules/@angular-devkit/build-angular/src/angular-cli-files/models/jit-polyfills.js": 
        /*!**************************************************************************************************!*\
          !*** ./node_modules/@angular-devkit/build-angular/src/angular-cli-files/models/jit-polyfills.js ***!
          \**************************************************************************************************/
        /*! no exports provided */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var core_js_proposals_reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/proposals/reflect-metadata */ "./node_modules/@angular-devkit/build-angular/node_modules/core-js/proposals/reflect-metadata.js");
            /* harmony import */ var core_js_proposals_reflect_metadata__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(core_js_proposals_reflect_metadata__WEBPACK_IMPORTED_MODULE_0__);
            /**
             * @license
             * Copyright Google Inc. All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            /***/ 
        }),
        /***/ "./node_modules/@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js": 
        /*!************************************************************************************!*\
          !*** ./node_modules/@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js ***!
          \************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports) {
            /**
            @license @nocompile
            Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
            This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
            The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
            The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
            Code distributed by Google as part of the polymer project is also
            subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
            */
            (function () {
                'use strict';
                (function () { if (void 0 === window.Reflect || void 0 === window.customElements || window.customElements.polyfillWrapFlushCallback)
                    return; var a = HTMLElement; window.HTMLElement = function HTMLElement() { return Reflect.construct(a, [], this.constructor); }, HTMLElement.prototype = a.prototype, HTMLElement.prototype.constructor = HTMLElement, Object.setPrototypeOf(HTMLElement, a); })();
            }());
            /***/ 
        }),
        /***/ "./node_modules/tslib/tslib.es6.js": 
        /*!*****************************************!*\
          !*** ./node_modules/tslib/tslib.es6.js ***!
          \*****************************************/
        /*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function () { return __extends; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function () { return __assign; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function () { return __rest; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function () { return __decorate; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function () { return __param; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function () { return __metadata; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function () { return __awaiter; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function () { return __generator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function () { return __exportStar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function () { return __values; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function () { return __read; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function () { return __spread; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function () { return __await; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function () { return __asyncGenerator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function () { return __asyncDelegator; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function () { return __asyncValues; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function () { return __makeTemplateObject; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function () { return __importStar; });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function () { return __importDefault; });
            /*! *****************************************************************************
            Copyright (c) Microsoft Corporation. All rights reserved.
            Licensed under the Apache License, Version 2.0 (the "License"); you may not use
            this file except in compliance with the License. You may obtain a copy of the
            License at http://www.apache.org/licenses/LICENSE-2.0
            
            THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
            KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
            WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
            MERCHANTABLITY OR NON-INFRINGEMENT.
            
            See the Apache Version 2.0 License for specific language governing permissions
            and limitations under the License.
            ***************************************************************************** */
            /* global Reflect, Promise */
            var extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b)
                    if (b.hasOwnProperty(p))
                        d[p] = b[p]; };
            function __extends(d, b) {
                extendStatics(d, b);
                function __() { this.constructor = d; }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            var __assign = Object.assign || function __assign(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s)
                        if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                }
                return t;
            };
            function __rest(s, e) {
                var t = {};
                for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
                        t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function")
                    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
                        if (e.indexOf(p[i]) < 0)
                            t[p[i]] = s[p[i]];
                return t;
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
                    r = Reflect.decorate(decorators, target, key, desc);
                else
                    for (var i = decorators.length - 1; i >= 0; i--)
                        if (d = decorators[i])
                            r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __param(paramIndex, decorator) {
                return function (target, key) { decorator(target, key, paramIndex); };
            }
            function __metadata(metadataKey, metadataValue) {
                if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
                    return Reflect.metadata(metadataKey, metadataValue);
            }
            function __awaiter(thisArg, _arguments, P, generator) {
                return new (P || (P = Promise))(function (resolve, reject) {
                    function fulfilled(value) { try {
                        step(generator.next(value));
                    }
                    catch (e) {
                        reject(e);
                    } }
                    function rejected(value) { try {
                        step(generator["throw"](value));
                    }
                    catch (e) {
                        reject(e);
                    } }
                    function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            }
            function __generator(thisArg, body) {
                var _ = { label: 0, sent: function () { if (t[0] & 1)
                        throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
                return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
                function verb(n) { return function (v) { return step([n, v]); }; }
                function step(op) {
                    if (f)
                        throw new TypeError("Generator is already executing.");
                    while (_)
                        try {
                            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                                return t;
                            if (y = 0, t)
                                op = [0, t.value];
                            switch (op[0]) {
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return { value: op[1], done: false };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [0];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2])
                                        _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        }
                        catch (e) {
                            op = [6, e];
                            y = 0;
                        }
                        finally {
                            f = t = 0;
                        }
                    if (op[0] & 5)
                        throw op[1];
                    return { value: op[0] ? op[1] : void 0, done: true };
                }
            }
            function __exportStar(m, exports) {
                for (var p in m)
                    if (!exports.hasOwnProperty(p))
                        exports[p] = m[p];
            }
            function __values(o) {
                var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
                if (m)
                    return m.call(o);
                return {
                    next: function () {
                        if (o && i >= o.length)
                            o = void 0;
                        return { value: o && o[i++], done: !o };
                    }
                };
            }
            function __read(o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m)
                    return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
                        ar.push(r.value);
                }
                catch (error) {
                    e = { error: error };
                }
                finally {
                    try {
                        if (r && !r.done && (m = i["return"]))
                            m.call(i);
                    }
                    finally {
                        if (e)
                            throw e.error;
                    }
                }
                return ar;
            }
            function __spread() {
                for (var ar = [], i = 0; i < arguments.length; i++)
                    ar = ar.concat(__read(arguments[i]));
                return ar;
            }
            function __await(v) {
                return this instanceof __await ? (this.v = v, this) : new __await(v);
            }
            function __asyncGenerator(thisArg, _arguments, generator) {
                if (!Symbol.asyncIterator)
                    throw new TypeError("Symbol.asyncIterator is not defined.");
                var g = generator.apply(thisArg, _arguments || []), i, q = [];
                return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
                function verb(n) { if (g[n])
                    i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
                function resume(n, v) { try {
                    step(g[n](v));
                }
                catch (e) {
                    settle(q[0][3], e);
                } }
                function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
                function fulfill(value) { resume("next", value); }
                function reject(value) { resume("throw", value); }
                function settle(f, v) { if (f(v), q.shift(), q.length)
                    resume(q[0][0], q[0][1]); }
            }
            function __asyncDelegator(o) {
                var i, p;
                return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
                function verb(n, f) { if (o[n])
                    i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
            }
            function __asyncValues(o) {
                if (!Symbol.asyncIterator)
                    throw new TypeError("Symbol.asyncIterator is not defined.");
                var m = o[Symbol.asyncIterator];
                return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
            }
            function __makeTemplateObject(cooked, raw) {
                if (Object.defineProperty) {
                    Object.defineProperty(cooked, "raw", { value: raw });
                }
                else {
                    cooked.raw = raw;
                }
                return cooked;
            }
            ;
            function __importStar(mod) {
                if (mod && mod.__esModule)
                    return mod;
                var result = {};
                if (mod != null)
                    for (var k in mod)
                        if (Object.hasOwnProperty.call(mod, k))
                            result[k] = mod[k];
                result.default = mod;
                return result;
            }
            function __importDefault(mod) {
                return (mod && mod.__esModule) ? mod : { default: mod };
            }
            /***/ 
        }),
        /***/ "./node_modules/zone.js/dist/zone-evergreen.js": 
        /*!*****************************************************!*\
          !*** ./node_modules/zone.js/dist/zone-evergreen.js ***!
          \*****************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
             * @license Angular v0.10.2
             * (c) 2010-2019 Google LLC. https://angular.io/
             * License: MIT
             */
            (function (factory) {
                true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                        (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                        __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
                    undefined;
            }(function () {
                'use strict';
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                var Zone$1 = (function (global) {
                    var performance = global['performance'];
                    function mark(name) { performance && performance['mark'] && performance['mark'](name); }
                    function performanceMeasure(name, label) {
                        performance && performance['measure'] && performance['measure'](name, label);
                    }
                    mark('Zone');
                    // Initialize before it's accessed below.
                    // __Zone_symbol_prefix global can be used to override the default zone
                    // symbol prefix with a custom one if needed.
                    var symbolPrefix = global['__Zone_symbol_prefix'] || '__zone_symbol__';
                    function __symbol__(name) { return symbolPrefix + name; }
                    var checkDuplicate = global[__symbol__('forceDuplicateZoneCheck')] === true;
                    if (global['Zone']) {
                        // if global['Zone'] already exists (maybe zone.js was already loaded or
                        // some other lib also registered a global object named Zone), we may need
                        // to throw an error, but sometimes user may not want this error.
                        // For example,
                        // we have two web pages, page1 includes zone.js, page2 doesn't.
                        // and the 1st time user load page1 and page2, everything work fine,
                        // but when user load page2 again, error occurs because global['Zone'] already exists.
                        // so we add a flag to let user choose whether to throw this error or not.
                        // By default, if existing Zone is from zone.js, we will not throw the error.
                        if (checkDuplicate || typeof global['Zone'].__symbol__ !== 'function') {
                            throw new Error('Zone already loaded.');
                        }
                        else {
                            return global['Zone'];
                        }
                    }
                    var Zone = /** @class */ (function () {
                        function Zone(parent, zoneSpec) {
                            this._parent = parent;
                            this._name = zoneSpec ? zoneSpec.name || 'unnamed' : '<root>';
                            this._properties = zoneSpec && zoneSpec.properties || {};
                            this._zoneDelegate =
                                new ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
                        }
                        Zone.assertZonePatched = function () {
                            if (global['Promise'] !== patches['ZoneAwarePromise']) {
                                throw new Error('Zone.js has detected that ZoneAwarePromise `(window|global).Promise` ' +
                                    'has been overwritten.\n' +
                                    'Most likely cause is that a Promise polyfill has been loaded ' +
                                    'after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. ' +
                                    'If you must load one, do so before loading zone.js.)');
                            }
                        };
                        Object.defineProperty(Zone, "root", {
                            get: function () {
                                var zone = Zone.current;
                                while (zone.parent) {
                                    zone = zone.parent;
                                }
                                return zone;
                            },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(Zone, "current", {
                            get: function () { return _currentZoneFrame.zone; },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(Zone, "currentTask", {
                            get: function () { return _currentTask; },
                            enumerable: true,
                            configurable: true
                        });
                        // tslint:disable-next-line:require-internal-with-underscore
                        Zone.__load_patch = function (name, fn) {
                            if (patches.hasOwnProperty(name)) {
                                if (checkDuplicate) {
                                    throw Error('Already loaded patch: ' + name);
                                }
                            }
                            else if (!global['__Zone_disable_' + name]) {
                                var perfName = 'Zone:' + name;
                                mark(perfName);
                                patches[name] = fn(global, Zone, _api);
                                performanceMeasure(perfName, perfName);
                            }
                        };
                        Object.defineProperty(Zone.prototype, "parent", {
                            get: function () { return this._parent; },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(Zone.prototype, "name", {
                            get: function () { return this._name; },
                            enumerable: true,
                            configurable: true
                        });
                        Zone.prototype.get = function (key) {
                            var zone = this.getZoneWith(key);
                            if (zone)
                                return zone._properties[key];
                        };
                        Zone.prototype.getZoneWith = function (key) {
                            var current = this;
                            while (current) {
                                if (current._properties.hasOwnProperty(key)) {
                                    return current;
                                }
                                current = current._parent;
                            }
                            return null;
                        };
                        Zone.prototype.fork = function (zoneSpec) {
                            if (!zoneSpec)
                                throw new Error('ZoneSpec required!');
                            return this._zoneDelegate.fork(this, zoneSpec);
                        };
                        Zone.prototype.wrap = function (callback, source) {
                            if (typeof callback !== 'function') {
                                throw new Error('Expecting function got: ' + callback);
                            }
                            var _callback = this._zoneDelegate.intercept(this, callback, source);
                            var zone = this;
                            return function () {
                                return zone.runGuarded(_callback, this, arguments, source);
                            };
                        };
                        Zone.prototype.run = function (callback, applyThis, applyArgs, source) {
                            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                            try {
                                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                            }
                            finally {
                                _currentZoneFrame = _currentZoneFrame.parent;
                            }
                        };
                        Zone.prototype.runGuarded = function (callback, applyThis, applyArgs, source) {
                            if (applyThis === void 0) { applyThis = null; }
                            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                            try {
                                try {
                                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                                }
                                catch (error) {
                                    if (this._zoneDelegate.handleError(this, error)) {
                                        throw error;
                                    }
                                }
                            }
                            finally {
                                _currentZoneFrame = _currentZoneFrame.parent;
                            }
                        };
                        Zone.prototype.runTask = function (task, applyThis, applyArgs) {
                            if (task.zone != this) {
                                throw new Error('A task can only be run in the zone of creation! (Creation: ' +
                                    (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
                            }
                            // https://github.com/angular/zone.js/issues/778, sometimes eventTask
                            // will run in notScheduled(canceled) state, we should not try to
                            // run such kind of task but just return
                            if (task.state === notScheduled && (task.type === eventTask || task.type === macroTask)) {
                                return;
                            }
                            var reEntryGuard = task.state != running;
                            reEntryGuard && task._transitionTo(running, scheduled);
                            task.runCount++;
                            var previousTask = _currentTask;
                            _currentTask = task;
                            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                            try {
                                if (task.type == macroTask && task.data && !task.data.isPeriodic) {
                                    task.cancelFn = undefined;
                                }
                                try {
                                    return this._zoneDelegate.invokeTask(this, task, applyThis, applyArgs);
                                }
                                catch (error) {
                                    if (this._zoneDelegate.handleError(this, error)) {
                                        throw error;
                                    }
                                }
                            }
                            finally {
                                // if the task's state is notScheduled or unknown, then it has already been cancelled
                                // we should not reset the state to scheduled
                                if (task.state !== notScheduled && task.state !== unknown) {
                                    if (task.type == eventTask || (task.data && task.data.isPeriodic)) {
                                        reEntryGuard && task._transitionTo(scheduled, running);
                                    }
                                    else {
                                        task.runCount = 0;
                                        this._updateTaskCount(task, -1);
                                        reEntryGuard &&
                                            task._transitionTo(notScheduled, running, notScheduled);
                                    }
                                }
                                _currentZoneFrame = _currentZoneFrame.parent;
                                _currentTask = previousTask;
                            }
                        };
                        Zone.prototype.scheduleTask = function (task) {
                            if (task.zone && task.zone !== this) {
                                // check if the task was rescheduled, the newZone
                                // should not be the children of the original zone
                                var newZone = this;
                                while (newZone) {
                                    if (newZone === task.zone) {
                                        throw Error("can not reschedule task to " + this.name + " which is descendants of the original zone " + task.zone.name);
                                    }
                                    newZone = newZone.parent;
                                }
                            }
                            task._transitionTo(scheduling, notScheduled);
                            var zoneDelegates = [];
                            task._zoneDelegates = zoneDelegates;
                            task._zone = this;
                            try {
                                task = this._zoneDelegate.scheduleTask(this, task);
                            }
                            catch (err) {
                                // should set task's state to unknown when scheduleTask throw error
                                // because the err may from reschedule, so the fromState maybe notScheduled
                                task._transitionTo(unknown, scheduling, notScheduled);
                                // TODO: @JiaLiPassion, should we check the result from handleError?
                                this._zoneDelegate.handleError(this, err);
                                throw err;
                            }
                            if (task._zoneDelegates === zoneDelegates) {
                                // we have to check because internally the delegate can reschedule the task.
                                this._updateTaskCount(task, 1);
                            }
                            if (task.state == scheduling) {
                                task._transitionTo(scheduled, scheduling);
                            }
                            return task;
                        };
                        Zone.prototype.scheduleMicroTask = function (source, callback, data, customSchedule) {
                            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, undefined));
                        };
                        Zone.prototype.scheduleMacroTask = function (source, callback, data, customSchedule, customCancel) {
                            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
                        };
                        Zone.prototype.scheduleEventTask = function (source, callback, data, customSchedule, customCancel) {
                            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
                        };
                        Zone.prototype.cancelTask = function (task) {
                            if (task.zone != this)
                                throw new Error('A task can only be cancelled in the zone of creation! (Creation: ' +
                                    (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
                            task._transitionTo(canceling, scheduled, running);
                            try {
                                this._zoneDelegate.cancelTask(this, task);
                            }
                            catch (err) {
                                // if error occurs when cancelTask, transit the state to unknown
                                task._transitionTo(unknown, canceling);
                                this._zoneDelegate.handleError(this, err);
                                throw err;
                            }
                            this._updateTaskCount(task, -1);
                            task._transitionTo(notScheduled, canceling);
                            task.runCount = 0;
                            return task;
                        };
                        Zone.prototype._updateTaskCount = function (task, count) {
                            var zoneDelegates = task._zoneDelegates;
                            if (count == -1) {
                                task._zoneDelegates = null;
                            }
                            for (var i = 0; i < zoneDelegates.length; i++) {
                                zoneDelegates[i]._updateTaskCount(task.type, count);
                            }
                        };
                        return Zone;
                    }());
                    // tslint:disable-next-line:require-internal-with-underscore
                    Zone.__symbol__ = __symbol__;
                    var DELEGATE_ZS = {
                        name: '',
                        onHasTask: function (delegate, _, target, hasTaskState) { return delegate.hasTask(target, hasTaskState); },
                        onScheduleTask: function (delegate, _, target, task) { return delegate.scheduleTask(target, task); },
                        onInvokeTask: function (delegate, _, target, task, applyThis, applyArgs) { return delegate.invokeTask(target, task, applyThis, applyArgs); },
                        onCancelTask: function (delegate, _, target, task) { return delegate.cancelTask(target, task); }
                    };
                    var ZoneDelegate = /** @class */ (function () {
                        function ZoneDelegate(zone, parentDelegate, zoneSpec) {
                            this._taskCounts = { 'microTask': 0, 'macroTask': 0, 'eventTask': 0 };
                            this.zone = zone;
                            this._parentDelegate = parentDelegate;
                            this._forkZS =
                                zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
                            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
                            this._forkCurrZone =
                                zoneSpec && (zoneSpec.onFork ? this.zone : parentDelegate._forkCurrZone);
                            this._interceptZS =
                                zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
                            this._interceptDlgt =
                                zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
                            this._interceptCurrZone =
                                zoneSpec && (zoneSpec.onIntercept ? this.zone : parentDelegate._interceptCurrZone);
                            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
                            this._invokeDlgt =
                                zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
                            this._invokeCurrZone =
                                zoneSpec && (zoneSpec.onInvoke ? this.zone : parentDelegate._invokeCurrZone);
                            this._handleErrorZS =
                                zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
                            this._handleErrorDlgt = zoneSpec &&
                                (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
                            this._handleErrorCurrZone =
                                zoneSpec && (zoneSpec.onHandleError ? this.zone : parentDelegate._handleErrorCurrZone);
                            this._scheduleTaskZS =
                                zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
                            this._scheduleTaskDlgt = zoneSpec &&
                                (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
                            this._scheduleTaskCurrZone = zoneSpec &&
                                (zoneSpec.onScheduleTask ? this.zone : parentDelegate._scheduleTaskCurrZone);
                            this._invokeTaskZS =
                                zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
                            this._invokeTaskDlgt =
                                zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
                            this._invokeTaskCurrZone =
                                zoneSpec && (zoneSpec.onInvokeTask ? this.zone : parentDelegate._invokeTaskCurrZone);
                            this._cancelTaskZS =
                                zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
                            this._cancelTaskDlgt =
                                zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
                            this._cancelTaskCurrZone =
                                zoneSpec && (zoneSpec.onCancelTask ? this.zone : parentDelegate._cancelTaskCurrZone);
                            this._hasTaskZS = null;
                            this._hasTaskDlgt = null;
                            this._hasTaskDlgtOwner = null;
                            this._hasTaskCurrZone = null;
                            var zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
                            var parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
                            if (zoneSpecHasTask || parentHasTask) {
                                // If we need to report hasTask, than this ZS needs to do ref counting on tasks. In such
                                // a case all task related interceptors must go through this ZD. We can't short circuit it.
                                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                                this._hasTaskDlgt = parentDelegate;
                                this._hasTaskDlgtOwner = this;
                                this._hasTaskCurrZone = zone;
                                if (!zoneSpec.onScheduleTask) {
                                    this._scheduleTaskZS = DELEGATE_ZS;
                                    this._scheduleTaskDlgt = parentDelegate;
                                    this._scheduleTaskCurrZone = this.zone;
                                }
                                if (!zoneSpec.onInvokeTask) {
                                    this._invokeTaskZS = DELEGATE_ZS;
                                    this._invokeTaskDlgt = parentDelegate;
                                    this._invokeTaskCurrZone = this.zone;
                                }
                                if (!zoneSpec.onCancelTask) {
                                    this._cancelTaskZS = DELEGATE_ZS;
                                    this._cancelTaskDlgt = parentDelegate;
                                    this._cancelTaskCurrZone = this.zone;
                                }
                            }
                        }
                        ZoneDelegate.prototype.fork = function (targetZone, zoneSpec) {
                            return this._forkZS ?
                                this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) :
                                new Zone(targetZone, zoneSpec);
                        };
                        ZoneDelegate.prototype.intercept = function (targetZone, callback, source) {
                            return this._interceptZS ?
                                this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) :
                                callback;
                        };
                        ZoneDelegate.prototype.invoke = function (targetZone, callback, applyThis, applyArgs, source) {
                            return this._invokeZS ?
                                this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) :
                                callback.apply(applyThis, applyArgs);
                        };
                        ZoneDelegate.prototype.handleError = function (targetZone, error) {
                            return this._handleErrorZS ?
                                this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) :
                                true;
                        };
                        ZoneDelegate.prototype.scheduleTask = function (targetZone, task) {
                            var returnTask = task;
                            if (this._scheduleTaskZS) {
                                if (this._hasTaskZS) {
                                    returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                                }
                                // clang-format off
                                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                                // clang-format on
                                if (!returnTask)
                                    returnTask = task;
                            }
                            else {
                                if (task.scheduleFn) {
                                    task.scheduleFn(task);
                                }
                                else if (task.type == microTask) {
                                    scheduleMicroTask(task);
                                }
                                else {
                                    throw new Error('Task is missing scheduleFn.');
                                }
                            }
                            return returnTask;
                        };
                        ZoneDelegate.prototype.invokeTask = function (targetZone, task, applyThis, applyArgs) {
                            return this._invokeTaskZS ?
                                this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) :
                                task.callback.apply(applyThis, applyArgs);
                        };
                        ZoneDelegate.prototype.cancelTask = function (targetZone, task) {
                            var value;
                            if (this._cancelTaskZS) {
                                value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
                            }
                            else {
                                if (!task.cancelFn) {
                                    throw Error('Task is not cancelable');
                                }
                                value = task.cancelFn(task);
                            }
                            return value;
                        };
                        ZoneDelegate.prototype.hasTask = function (targetZone, isEmpty) {
                            // hasTask should not throw error so other ZoneDelegate
                            // can still trigger hasTask callback
                            try {
                                this._hasTaskZS &&
                                    this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
                            }
                            catch (err) {
                                this.handleError(targetZone, err);
                            }
                        };
                        // tslint:disable-next-line:require-internal-with-underscore
                        ZoneDelegate.prototype._updateTaskCount = function (type, count) {
                            var counts = this._taskCounts;
                            var prev = counts[type];
                            var next = counts[type] = prev + count;
                            if (next < 0) {
                                throw new Error('More tasks executed then were scheduled.');
                            }
                            if (prev == 0 || next == 0) {
                                var isEmpty = {
                                    microTask: counts['microTask'] > 0,
                                    macroTask: counts['macroTask'] > 0,
                                    eventTask: counts['eventTask'] > 0,
                                    change: type
                                };
                                this.hasTask(this.zone, isEmpty);
                            }
                        };
                        return ZoneDelegate;
                    }());
                    var ZoneTask = /** @class */ (function () {
                        function ZoneTask(type, source, callback, options, scheduleFn, cancelFn) {
                            // tslint:disable-next-line:require-internal-with-underscore
                            this._zone = null;
                            this.runCount = 0;
                            // tslint:disable-next-line:require-internal-with-underscore
                            this._zoneDelegates = null;
                            // tslint:disable-next-line:require-internal-with-underscore
                            this._state = 'notScheduled';
                            this.type = type;
                            this.source = source;
                            this.data = options;
                            this.scheduleFn = scheduleFn;
                            this.cancelFn = cancelFn;
                            if (!callback) {
                                throw new Error('callback is not defined');
                            }
                            this.callback = callback;
                            var self = this;
                            // TODO: @JiaLiPassion options should have interface
                            if (type === eventTask && options && options.useG) {
                                this.invoke = ZoneTask.invokeTask;
                            }
                            else {
                                this.invoke = function () {
                                    return ZoneTask.invokeTask.call(global, self, this, arguments);
                                };
                            }
                        }
                        ZoneTask.invokeTask = function (task, target, args) {
                            if (!task) {
                                task = this;
                            }
                            _numberOfNestedTaskFrames++;
                            try {
                                task.runCount++;
                                return task.zone.runTask(task, target, args);
                            }
                            finally {
                                if (_numberOfNestedTaskFrames == 1) {
                                    drainMicroTaskQueue();
                                }
                                _numberOfNestedTaskFrames--;
                            }
                        };
                        Object.defineProperty(ZoneTask.prototype, "zone", {
                            get: function () { return this._zone; },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(ZoneTask.prototype, "state", {
                            get: function () { return this._state; },
                            enumerable: true,
                            configurable: true
                        });
                        ZoneTask.prototype.cancelScheduleRequest = function () { this._transitionTo(notScheduled, scheduling); };
                        // tslint:disable-next-line:require-internal-with-underscore
                        ZoneTask.prototype._transitionTo = function (toState, fromState1, fromState2) {
                            if (this._state === fromState1 || this._state === fromState2) {
                                this._state = toState;
                                if (toState == notScheduled) {
                                    this._zoneDelegates = null;
                                }
                            }
                            else {
                                throw new Error(this.type + " '" + this.source + "': can not transition to '" + toState + "', expecting state '" + fromState1 + "'" + (fromState2 ? ' or \'' + fromState2 + '\'' : '') + ", was '" + this._state + "'.");
                            }
                        };
                        ZoneTask.prototype.toString = function () {
                            if (this.data && typeof this.data.handleId !== 'undefined') {
                                return this.data.handleId.toString();
                            }
                            else {
                                return Object.prototype.toString.call(this);
                            }
                        };
                        // add toJSON method to prevent cyclic error when
                        // call JSON.stringify(zoneTask)
                        ZoneTask.prototype.toJSON = function () {
                            return {
                                type: this.type,
                                state: this.state,
                                source: this.source,
                                zone: this.zone.name,
                                runCount: this.runCount
                            };
                        };
                        return ZoneTask;
                    }());
                    //////////////////////////////////////////////////////
                    //////////////////////////////////////////////////////
                    ///  MICROTASK QUEUE
                    //////////////////////////////////////////////////////
                    //////////////////////////////////////////////////////
                    var symbolSetTimeout = __symbol__('setTimeout');
                    var symbolPromise = __symbol__('Promise');
                    var symbolThen = __symbol__('then');
                    var _microTaskQueue = [];
                    var _isDrainingMicrotaskQueue = false;
                    var nativeMicroTaskQueuePromise;
                    function scheduleMicroTask(task) {
                        // if we are not running in any task, and there has not been anything scheduled
                        // we must bootstrap the initial task creation by manually scheduling the drain
                        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) {
                            // We are not running in Task, so we need to kickstart the microtask queue.
                            if (!nativeMicroTaskQueuePromise) {
                                if (global[symbolPromise]) {
                                    nativeMicroTaskQueuePromise = global[symbolPromise].resolve(0);
                                }
                            }
                            if (nativeMicroTaskQueuePromise) {
                                var nativeThen = nativeMicroTaskQueuePromise[symbolThen];
                                if (!nativeThen) {
                                    // native Promise is not patchable, we need to use `then` directly
                                    // issue 1078
                                    nativeThen = nativeMicroTaskQueuePromise['then'];
                                }
                                nativeThen.call(nativeMicroTaskQueuePromise, drainMicroTaskQueue);
                            }
                            else {
                                global[symbolSetTimeout](drainMicroTaskQueue, 0);
                            }
                        }
                        task && _microTaskQueue.push(task);
                    }
                    function drainMicroTaskQueue() {
                        if (!_isDrainingMicrotaskQueue) {
                            _isDrainingMicrotaskQueue = true;
                            while (_microTaskQueue.length) {
                                var queue = _microTaskQueue;
                                _microTaskQueue = [];
                                for (var i = 0; i < queue.length; i++) {
                                    var task = queue[i];
                                    try {
                                        task.zone.runTask(task, null, null);
                                    }
                                    catch (error) {
                                        _api.onUnhandledError(error);
                                    }
                                }
                            }
                            _api.microtaskDrainDone();
                            _isDrainingMicrotaskQueue = false;
                        }
                    }
                    //////////////////////////////////////////////////////
                    //////////////////////////////////////////////////////
                    ///  BOOTSTRAP
                    //////////////////////////////////////////////////////
                    //////////////////////////////////////////////////////
                    var NO_ZONE = { name: 'NO ZONE' };
                    var notScheduled = 'notScheduled', scheduling = 'scheduling', scheduled = 'scheduled', running = 'running', canceling = 'canceling', unknown = 'unknown';
                    var microTask = 'microTask', macroTask = 'macroTask', eventTask = 'eventTask';
                    var patches = {};
                    var _api = {
                        symbol: __symbol__,
                        currentZoneFrame: function () { return _currentZoneFrame; },
                        onUnhandledError: noop,
                        microtaskDrainDone: noop,
                        scheduleMicroTask: scheduleMicroTask,
                        showUncaughtError: function () { return !Zone[__symbol__('ignoreConsoleErrorUncaughtError')]; },
                        patchEventTarget: function () { return []; },
                        patchOnProperties: noop,
                        patchMethod: function () { return noop; },
                        bindArguments: function () { return []; },
                        patchThen: function () { return noop; },
                        patchMacroTask: function () { return noop; },
                        setNativePromise: function (NativePromise) {
                            // sometimes NativePromise.resolve static function
                            // is not ready yet, (such as core-js/es6.promise)
                            // so we need to check here.
                            if (NativePromise && typeof NativePromise.resolve === 'function') {
                                nativeMicroTaskQueuePromise = NativePromise.resolve(0);
                            }
                        },
                        patchEventPrototype: function () { return noop; },
                        isIEOrEdge: function () { return false; },
                        getGlobalObjects: function () { return undefined; },
                        ObjectDefineProperty: function () { return noop; },
                        ObjectGetOwnPropertyDescriptor: function () { return undefined; },
                        ObjectCreate: function () { return undefined; },
                        ArraySlice: function () { return []; },
                        patchClass: function () { return noop; },
                        wrapWithCurrentZone: function () { return noop; },
                        filterProperties: function () { return []; },
                        attachOriginToPatched: function () { return noop; },
                        _redefineProperty: function () { return noop; },
                        patchCallbacks: function () { return noop; }
                    };
                    var _currentZoneFrame = { parent: null, zone: new Zone(null, null) };
                    var _currentTask = null;
                    var _numberOfNestedTaskFrames = 0;
                    function noop() { }
                    performanceMeasure('Zone', 'Zone');
                    return global['Zone'] = Zone;
                })(typeof window !== 'undefined' && window || typeof self !== 'undefined' && self || global);
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                Zone.__load_patch('ZoneAwarePromise', function (global, Zone, api) {
                    var ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                    var ObjectDefineProperty = Object.defineProperty;
                    function readableObjectToString(obj) {
                        if (obj && obj.toString === Object.prototype.toString) {
                            var className = obj.constructor && obj.constructor.name;
                            return (className ? className : '') + ': ' + JSON.stringify(obj);
                        }
                        return obj ? obj.toString() : Object.prototype.toString.call(obj);
                    }
                    var __symbol__ = api.symbol;
                    var _uncaughtPromiseErrors = [];
                    var symbolPromise = __symbol__('Promise');
                    var symbolThen = __symbol__('then');
                    var creationTrace = '__creationTrace__';
                    api.onUnhandledError = function (e) {
                        if (api.showUncaughtError()) {
                            var rejection = e && e.rejection;
                            if (rejection) {
                                console.error('Unhandled Promise rejection:', rejection instanceof Error ? rejection.message : rejection, '; Zone:', e.zone.name, '; Task:', e.task && e.task.source, '; Value:', rejection, rejection instanceof Error ? rejection.stack : undefined);
                            }
                            else {
                                console.error(e);
                            }
                        }
                    };
                    api.microtaskDrainDone = function () {
                        while (_uncaughtPromiseErrors.length) {
                            var _loop_1 = function () {
                                var uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                                try {
                                    uncaughtPromiseError.zone.runGuarded(function () { throw uncaughtPromiseError; });
                                }
                                catch (error) {
                                    handleUnhandledRejection(error);
                                }
                            };
                            while (_uncaughtPromiseErrors.length) {
                                _loop_1();
                            }
                        }
                    };
                    var UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__('unhandledPromiseRejectionHandler');
                    function handleUnhandledRejection(e) {
                        api.onUnhandledError(e);
                        try {
                            var handler = Zone[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                            if (handler && typeof handler === 'function') {
                                handler.call(this, e);
                            }
                        }
                        catch (err) {
                        }
                    }
                    function isThenable(value) { return value && value.then; }
                    function forwardResolution(value) { return value; }
                    function forwardRejection(rejection) { return ZoneAwarePromise.reject(rejection); }
                    var symbolState = __symbol__('state');
                    var symbolValue = __symbol__('value');
                    var symbolFinally = __symbol__('finally');
                    var symbolParentPromiseValue = __symbol__('parentPromiseValue');
                    var symbolParentPromiseState = __symbol__('parentPromiseState');
                    var source = 'Promise.then';
                    var UNRESOLVED = null;
                    var RESOLVED = true;
                    var REJECTED = false;
                    var REJECTED_NO_CATCH = 0;
                    function makeResolver(promise, state) {
                        return function (v) {
                            try {
                                resolvePromise(promise, state, v);
                            }
                            catch (err) {
                                resolvePromise(promise, false, err);
                            }
                            // Do not return value or you will break the Promise spec.
                        };
                    }
                    var once = function () {
                        var wasCalled = false;
                        return function wrapper(wrappedFunction) {
                            return function () {
                                if (wasCalled) {
                                    return;
                                }
                                wasCalled = true;
                                wrappedFunction.apply(null, arguments);
                            };
                        };
                    };
                    var TYPE_ERROR = 'Promise resolved with itself';
                    var CURRENT_TASK_TRACE_SYMBOL = __symbol__('currentTaskTrace');
                    // Promise Resolution
                    function resolvePromise(promise, state, value) {
                        var onceWrapper = once();
                        if (promise === value) {
                            throw new TypeError(TYPE_ERROR);
                        }
                        if (promise[symbolState] === UNRESOLVED) {
                            // should only get value.then once based on promise spec.
                            var then = null;
                            try {
                                if (typeof value === 'object' || typeof value === 'function') {
                                    then = value && value.then;
                                }
                            }
                            catch (err) {
                                onceWrapper(function () { resolvePromise(promise, false, err); })();
                                return promise;
                            }
                            // if (value instanceof ZoneAwarePromise) {
                            if (state !== REJECTED && value instanceof ZoneAwarePromise &&
                                value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) &&
                                value[symbolState] !== UNRESOLVED) {
                                clearRejectedNoCatch(value);
                                resolvePromise(promise, value[symbolState], value[symbolValue]);
                            }
                            else if (state !== REJECTED && typeof then === 'function') {
                                try {
                                    then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                                }
                                catch (err) {
                                    onceWrapper(function () { resolvePromise(promise, false, err); })();
                                }
                            }
                            else {
                                promise[symbolState] = state;
                                var queue = promise[symbolValue];
                                promise[symbolValue] = value;
                                if (promise[symbolFinally] === symbolFinally) {
                                    // the promise is generated by Promise.prototype.finally
                                    if (state === RESOLVED) {
                                        // the state is resolved, should ignore the value
                                        // and use parent promise value
                                        promise[symbolState] = promise[symbolParentPromiseState];
                                        promise[symbolValue] = promise[symbolParentPromiseValue];
                                    }
                                }
                                // record task information in value when error occurs, so we can
                                // do some additional work such as render longStackTrace
                                if (state === REJECTED && value instanceof Error) {
                                    // check if longStackTraceZone is here
                                    var trace = Zone.currentTask && Zone.currentTask.data &&
                                        Zone.currentTask.data[creationTrace];
                                    if (trace) {
                                        // only keep the long stack trace into error when in longStackTraceZone
                                        ObjectDefineProperty(value, CURRENT_TASK_TRACE_SYMBOL, { configurable: true, enumerable: false, writable: true, value: trace });
                                    }
                                }
                                for (var i = 0; i < queue.length;) {
                                    scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                                }
                                if (queue.length == 0 && state == REJECTED) {
                                    promise[symbolState] = REJECTED_NO_CATCH;
                                    try {
                                        // try to print more readable error log
                                        throw new Error('Uncaught (in promise): ' + readableObjectToString(value) +
                                            (value && value.stack ? '\n' + value.stack : ''));
                                    }
                                    catch (err) {
                                        var error = err;
                                        error.rejection = value;
                                        error.promise = promise;
                                        error.zone = Zone.current;
                                        error.task = Zone.currentTask;
                                        _uncaughtPromiseErrors.push(error);
                                        api.scheduleMicroTask(); // to make sure that it is running
                                    }
                                }
                            }
                        }
                        // Resolving an already resolved promise is a noop.
                        return promise;
                    }
                    var REJECTION_HANDLED_HANDLER = __symbol__('rejectionHandledHandler');
                    function clearRejectedNoCatch(promise) {
                        if (promise[symbolState] === REJECTED_NO_CATCH) {
                            // if the promise is rejected no catch status
                            // and queue.length > 0, means there is a error handler
                            // here to handle the rejected promise, we should trigger
                            // windows.rejectionhandled eventHandler or nodejs rejectionHandled
                            // eventHandler
                            try {
                                var handler = Zone[REJECTION_HANDLED_HANDLER];
                                if (handler && typeof handler === 'function') {
                                    handler.call(this, { rejection: promise[symbolValue], promise: promise });
                                }
                            }
                            catch (err) {
                            }
                            promise[symbolState] = REJECTED;
                            for (var i = 0; i < _uncaughtPromiseErrors.length; i++) {
                                if (promise === _uncaughtPromiseErrors[i].promise) {
                                    _uncaughtPromiseErrors.splice(i, 1);
                                }
                            }
                        }
                    }
                    function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
                        clearRejectedNoCatch(promise);
                        var promiseState = promise[symbolState];
                        var delegate = promiseState ?
                            (typeof onFulfilled === 'function') ? onFulfilled : forwardResolution :
                            (typeof onRejected === 'function') ? onRejected : forwardRejection;
                        zone.scheduleMicroTask(source, function () {
                            try {
                                var parentPromiseValue = promise[symbolValue];
                                var isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                                if (isFinallyPromise) {
                                    // if the promise is generated from finally call, keep parent promise's state and value
                                    chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                                    chainPromise[symbolParentPromiseState] = promiseState;
                                }
                                // should not pass value to finally callback
                                var value = zone.run(delegate, undefined, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution ?
                                    [] :
                                    [parentPromiseValue]);
                                resolvePromise(chainPromise, true, value);
                            }
                            catch (error) {
                                // if error occurs, should always return this error
                                resolvePromise(chainPromise, false, error);
                            }
                        }, chainPromise);
                    }
                    var ZONE_AWARE_PROMISE_TO_STRING = 'function ZoneAwarePromise() { [native code] }';
                    var ZoneAwarePromise = /** @class */ (function () {
                        function ZoneAwarePromise(executor) {
                            var promise = this;
                            if (!(promise instanceof ZoneAwarePromise)) {
                                throw new Error('Must be an instanceof Promise.');
                            }
                            promise[symbolState] = UNRESOLVED;
                            promise[symbolValue] = []; // queue;
                            try {
                                executor && executor(makeResolver(promise, RESOLVED), makeResolver(promise, REJECTED));
                            }
                            catch (error) {
                                resolvePromise(promise, false, error);
                            }
                        }
                        ZoneAwarePromise.toString = function () { return ZONE_AWARE_PROMISE_TO_STRING; };
                        ZoneAwarePromise.resolve = function (value) {
                            return resolvePromise(new this(null), RESOLVED, value);
                        };
                        ZoneAwarePromise.reject = function (error) {
                            return resolvePromise(new this(null), REJECTED, error);
                        };
                        ZoneAwarePromise.race = function (values) {
                            var resolve;
                            var reject;
                            var promise = new this(function (res, rej) {
                                resolve = res;
                                reject = rej;
                            });
                            function onResolve(value) { resolve(value); }
                            function onReject(error) { reject(error); }
                            for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                                var value = values_1[_i];
                                if (!isThenable(value)) {
                                    value = this.resolve(value);
                                }
                                value.then(onResolve, onReject);
                            }
                            return promise;
                        };
                        ZoneAwarePromise.all = function (values) { return ZoneAwarePromise.allWithCallback(values); };
                        ZoneAwarePromise.allSettled = function (values) {
                            var P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                            return P.allWithCallback(values, {
                                thenCallback: function (value) { return ({ status: 'fulfilled', value: value }); },
                                errorCallback: function (err) { return ({ status: 'rejected', reason: err }); }
                            });
                        };
                        ZoneAwarePromise.allWithCallback = function (values, callback) {
                            var resolve;
                            var reject;
                            var promise = new this(function (res, rej) {
                                resolve = res;
                                reject = rej;
                            });
                            // Start at 2 to prevent prematurely resolving if .then is called immediately.
                            var unresolvedCount = 2;
                            var valueIndex = 0;
                            var resolvedValues = [];
                            var _loop_2 = function (value) {
                                if (!isThenable(value)) {
                                    value = this_1.resolve(value);
                                }
                                var curValueIndex = valueIndex;
                                try {
                                    value.then(function (value) {
                                        resolvedValues[curValueIndex] = callback ? callback.thenCallback(value) : value;
                                        unresolvedCount--;
                                        if (unresolvedCount === 0) {
                                            resolve(resolvedValues);
                                        }
                                    }, function (err) {
                                        if (!callback) {
                                            reject(err);
                                        }
                                        else {
                                            resolvedValues[curValueIndex] = callback.errorCallback(err);
                                            unresolvedCount--;
                                            if (unresolvedCount === 0) {
                                                resolve(resolvedValues);
                                            }
                                        }
                                    });
                                }
                                catch (thenErr) {
                                    reject(thenErr);
                                }
                                unresolvedCount++;
                                valueIndex++;
                            };
                            var this_1 = this;
                            for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
                                var value = values_2[_i];
                                _loop_2(value);
                            }
                            // Make the unresolvedCount zero-based again.
                            unresolvedCount -= 2;
                            if (unresolvedCount === 0) {
                                resolve(resolvedValues);
                            }
                            return promise;
                        };
                        Object.defineProperty(ZoneAwarePromise.prototype, Symbol.toStringTag, {
                            get: function () { return 'Promise'; },
                            enumerable: true,
                            configurable: true
                        });
                        ZoneAwarePromise.prototype.then = function (onFulfilled, onRejected) {
                            var chainPromise = new this.constructor(null);
                            var zone = Zone.current;
                            if (this[symbolState] == UNRESOLVED) {
                                this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                            }
                            else {
                                scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                            }
                            return chainPromise;
                        };
                        ZoneAwarePromise.prototype.catch = function (onRejected) {
                            return this.then(null, onRejected);
                        };
                        ZoneAwarePromise.prototype.finally = function (onFinally) {
                            var chainPromise = new this.constructor(null);
                            chainPromise[symbolFinally] = symbolFinally;
                            var zone = Zone.current;
                            if (this[symbolState] == UNRESOLVED) {
                                this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                            }
                            else {
                                scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                            }
                            return chainPromise;
                        };
                        return ZoneAwarePromise;
                    }());
                    // Protect against aggressive optimizers dropping seemingly unused properties.
                    // E.g. Closure Compiler in advanced mode.
                    ZoneAwarePromise['resolve'] = ZoneAwarePromise.resolve;
                    ZoneAwarePromise['reject'] = ZoneAwarePromise.reject;
                    ZoneAwarePromise['race'] = ZoneAwarePromise.race;
                    ZoneAwarePromise['all'] = ZoneAwarePromise.all;
                    var NativePromise = global[symbolPromise] = global['Promise'];
                    var ZONE_AWARE_PROMISE = Zone.__symbol__('ZoneAwarePromise');
                    var desc = ObjectGetOwnPropertyDescriptor(global, 'Promise');
                    if (!desc || desc.configurable) {
                        desc && delete desc.writable;
                        desc && delete desc.value;
                        if (!desc) {
                            desc = { configurable: true, enumerable: true };
                        }
                        desc.get = function () {
                            // if we already set ZoneAwarePromise, use patched one
                            // otherwise return native one.
                            return global[ZONE_AWARE_PROMISE] ? global[ZONE_AWARE_PROMISE] : global[symbolPromise];
                        };
                        desc.set = function (NewNativePromise) {
                            if (NewNativePromise === ZoneAwarePromise) {
                                // if the NewNativePromise is ZoneAwarePromise
                                // save to global
                                global[ZONE_AWARE_PROMISE] = NewNativePromise;
                            }
                            else {
                                // if the NewNativePromise is not ZoneAwarePromise
                                // for example: after load zone.js, some library just
                                // set es6-promise to global, if we set it to global
                                // directly, assertZonePatched will fail and angular
                                // will not loaded, so we just set the NewNativePromise
                                // to global[symbolPromise], so the result is just like
                                // we load ES6 Promise before zone.js
                                global[symbolPromise] = NewNativePromise;
                                if (!NewNativePromise.prototype[symbolThen]) {
                                    patchThen(NewNativePromise);
                                }
                                api.setNativePromise(NewNativePromise);
                            }
                        };
                        ObjectDefineProperty(global, 'Promise', desc);
                    }
                    global['Promise'] = ZoneAwarePromise;
                    var symbolThenPatched = __symbol__('thenPatched');
                    function patchThen(Ctor) {
                        var proto = Ctor.prototype;
                        var prop = ObjectGetOwnPropertyDescriptor(proto, 'then');
                        if (prop && (prop.writable === false || !prop.configurable)) {
                            // check Ctor.prototype.then propertyDescriptor is writable or not
                            // in meteor env, writable is false, we should ignore such case
                            return;
                        }
                        var originalThen = proto.then;
                        // Keep a reference to the original method.
                        proto[symbolThen] = originalThen;
                        Ctor.prototype.then = function (onResolve, onReject) {
                            var _this = this;
                            var wrapped = new ZoneAwarePromise(function (resolve, reject) { originalThen.call(_this, resolve, reject); });
                            return wrapped.then(onResolve, onReject);
                        };
                        Ctor[symbolThenPatched] = true;
                    }
                    api.patchThen = patchThen;
                    function zoneify(fn) {
                        return function () {
                            var resultPromise = fn.apply(this, arguments);
                            if (resultPromise instanceof ZoneAwarePromise) {
                                return resultPromise;
                            }
                            var ctor = resultPromise.constructor;
                            if (!ctor[symbolThenPatched]) {
                                patchThen(ctor);
                            }
                            return resultPromise;
                        };
                    }
                    if (NativePromise) {
                        patchThen(NativePromise);
                        var fetch = global['fetch'];
                        if (typeof fetch == 'function') {
                            global[api.symbol('fetch')] = fetch;
                            global['fetch'] = zoneify(fetch);
                        }
                    }
                    // This is not part of public API, but it is useful for tests, so we expose it.
                    Promise[Zone.__symbol__('uncaughtPromiseErrors')] = _uncaughtPromiseErrors;
                    return ZoneAwarePromise;
                });
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                /**
                 * Suppress closure compiler errors about unknown 'Zone' variable
                 * @fileoverview
                 * @suppress {undefinedVars,globalThis,missingRequire}
                 */
                /// <reference types="node"/>
                // issue #989, to reduce bundle size, use short name
                /** Object.getOwnPropertyDescriptor */
                var ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                /** Object.defineProperty */
                var ObjectDefineProperty = Object.defineProperty;
                /** Object.getPrototypeOf */
                var ObjectGetPrototypeOf = Object.getPrototypeOf;
                /** Object.create */
                var ObjectCreate = Object.create;
                /** Array.prototype.slice */
                var ArraySlice = Array.prototype.slice;
                /** addEventListener string const */
                var ADD_EVENT_LISTENER_STR = 'addEventListener';
                /** removeEventListener string const */
                var REMOVE_EVENT_LISTENER_STR = 'removeEventListener';
                /** zoneSymbol addEventListener */
                var ZONE_SYMBOL_ADD_EVENT_LISTENER = Zone.__symbol__(ADD_EVENT_LISTENER_STR);
                /** zoneSymbol removeEventListener */
                var ZONE_SYMBOL_REMOVE_EVENT_LISTENER = Zone.__symbol__(REMOVE_EVENT_LISTENER_STR);
                /** true string const */
                var TRUE_STR = 'true';
                /** false string const */
                var FALSE_STR = 'false';
                /** Zone symbol prefix string const. */
                var ZONE_SYMBOL_PREFIX = Zone.__symbol__('');
                function wrapWithCurrentZone(callback, source) {
                    return Zone.current.wrap(callback, source);
                }
                function scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
                    return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
                }
                var zoneSymbol = Zone.__symbol__;
                var isWindowExists = typeof window !== 'undefined';
                var internalWindow = isWindowExists ? window : undefined;
                var _global = isWindowExists && internalWindow || typeof self === 'object' && self || global;
                var REMOVE_ATTRIBUTE = 'removeAttribute';
                var NULL_ON_PROP_VALUE = [null];
                function bindArguments(args, source) {
                    for (var i = args.length - 1; i >= 0; i--) {
                        if (typeof args[i] === 'function') {
                            args[i] = wrapWithCurrentZone(args[i], source + '_' + i);
                        }
                    }
                    return args;
                }
                function patchPrototype(prototype, fnNames) {
                    var source = prototype.constructor['name'];
                    var _loop_3 = function (i) {
                        var name = fnNames[i];
                        var delegate = prototype[name];
                        if (delegate) {
                            var prototypeDesc = ObjectGetOwnPropertyDescriptor(prototype, name);
                            if (!isPropertyWritable(prototypeDesc)) {
                                return "continue";
                            }
                            prototype[name] = (function (delegate) {
                                var patched = function () {
                                    return delegate.apply(this, bindArguments(arguments, source + '.' + name));
                                };
                                attachOriginToPatched(patched, delegate);
                                return patched;
                            })(delegate);
                        }
                    };
                    for (var i = 0; i < fnNames.length; i++) {
                        _loop_3(i);
                    }
                }
                function isPropertyWritable(propertyDesc) {
                    if (!propertyDesc) {
                        return true;
                    }
                    if (propertyDesc.writable === false) {
                        return false;
                    }
                    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
                }
                var isWebWorker = (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope);
                // Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
                // this code.
                var isNode = (!('nw' in _global) && typeof _global.process !== 'undefined' &&
                    {}.toString.call(_global.process) === '[object process]');
                var isBrowser = !isNode && !isWebWorker && !!(isWindowExists && internalWindow['HTMLElement']);
                // we are in electron of nw, so we are both browser and nodejs
                // Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
                // this code.
                var isMix = typeof _global.process !== 'undefined' &&
                    {}.toString.call(_global.process) === '[object process]' && !isWebWorker &&
                    !!(isWindowExists && internalWindow['HTMLElement']);
                var zoneSymbolEventNames = {};
                var wrapFn = function (event) {
                    // https://github.com/angular/zone.js/issues/911, in IE, sometimes
                    // event will be undefined, so we need to use window.event
                    event = event || _global.event;
                    if (!event) {
                        return;
                    }
                    var eventNameSymbol = zoneSymbolEventNames[event.type];
                    if (!eventNameSymbol) {
                        eventNameSymbol = zoneSymbolEventNames[event.type] = zoneSymbol('ON_PROPERTY' + event.type);
                    }
                    var target = this || event.target || _global;
                    var listener = target[eventNameSymbol];
                    var result;
                    if (isBrowser && target === internalWindow && event.type === 'error') {
                        // window.onerror have different signiture
                        // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#window.onerror
                        // and onerror callback will prevent default when callback return true
                        var errorEvent = event;
                        result = listener &&
                            listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
                        if (result === true) {
                            event.preventDefault();
                        }
                    }
                    else {
                        result = listener && listener.apply(this, arguments);
                        if (result != undefined && !result) {
                            event.preventDefault();
                        }
                    }
                    return result;
                };
                function patchProperty(obj, prop, prototype) {
                    var desc = ObjectGetOwnPropertyDescriptor(obj, prop);
                    if (!desc && prototype) {
                        // when patch window object, use prototype to check prop exist or not
                        var prototypeDesc = ObjectGetOwnPropertyDescriptor(prototype, prop);
                        if (prototypeDesc) {
                            desc = { enumerable: true, configurable: true };
                        }
                    }
                    // if the descriptor not exists or is not configurable
                    // just return
                    if (!desc || !desc.configurable) {
                        return;
                    }
                    var onPropPatchedSymbol = zoneSymbol('on' + prop + 'patched');
                    if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) {
                        return;
                    }
                    // A property descriptor cannot have getter/setter and be writable
                    // deleting the writable and value properties avoids this error:
                    //
                    // TypeError: property descriptors must not specify a value or be writable when a
                    // getter or setter has been specified
                    delete desc.writable;
                    delete desc.value;
                    var originalDescGet = desc.get;
                    var originalDescSet = desc.set;
                    // substr(2) cuz 'onclick' -> 'click', etc
                    var eventName = prop.substr(2);
                    var eventNameSymbol = zoneSymbolEventNames[eventName];
                    if (!eventNameSymbol) {
                        eventNameSymbol = zoneSymbolEventNames[eventName] = zoneSymbol('ON_PROPERTY' + eventName);
                    }
                    desc.set = function (newValue) {
                        // in some of windows's onproperty callback, this is undefined
                        // so we need to check it
                        var target = this;
                        if (!target && obj === _global) {
                            target = _global;
                        }
                        if (!target) {
                            return;
                        }
                        var previousValue = target[eventNameSymbol];
                        if (previousValue) {
                            target.removeEventListener(eventName, wrapFn);
                        }
                        // issue #978, when onload handler was added before loading zone.js
                        // we should remove it with originalDescSet
                        if (originalDescSet) {
                            originalDescSet.apply(target, NULL_ON_PROP_VALUE);
                        }
                        if (typeof newValue === 'function') {
                            target[eventNameSymbol] = newValue;
                            target.addEventListener(eventName, wrapFn, false);
                        }
                        else {
                            target[eventNameSymbol] = null;
                        }
                    };
                    // The getter would return undefined for unassigned properties but the default value of an
                    // unassigned property is null
                    desc.get = function () {
                        // in some of windows's onproperty callback, this is undefined
                        // so we need to check it
                        var target = this;
                        if (!target && obj === _global) {
                            target = _global;
                        }
                        if (!target) {
                            return null;
                        }
                        var listener = target[eventNameSymbol];
                        if (listener) {
                            return listener;
                        }
                        else if (originalDescGet) {
                            // result will be null when use inline event attribute,
                            // such as <button onclick="func();">OK</button>
                            // because the onclick function is internal raw uncompiled handler
                            // the onclick will be evaluated when first time event was triggered or
                            // the property is accessed, https://github.com/angular/zone.js/issues/525
                            // so we should use original native get to retrieve the handler
                            var value = originalDescGet && originalDescGet.call(this);
                            if (value) {
                                desc.set.call(this, value);
                                if (typeof target[REMOVE_ATTRIBUTE] === 'function') {
                                    target.removeAttribute(prop);
                                }
                                return value;
                            }
                        }
                        return null;
                    };
                    ObjectDefineProperty(obj, prop, desc);
                    obj[onPropPatchedSymbol] = true;
                }
                function patchOnProperties(obj, properties, prototype) {
                    if (properties) {
                        for (var i = 0; i < properties.length; i++) {
                            patchProperty(obj, 'on' + properties[i], prototype);
                        }
                    }
                    else {
                        var onProperties = [];
                        for (var prop in obj) {
                            if (prop.substr(0, 2) == 'on') {
                                onProperties.push(prop);
                            }
                        }
                        for (var j = 0; j < onProperties.length; j++) {
                            patchProperty(obj, onProperties[j], prototype);
                        }
                    }
                }
                var originalInstanceKey = zoneSymbol('originalInstance');
                // wrap some native API on `window`
                function patchClass(className) {
                    var OriginalClass = _global[className];
                    if (!OriginalClass)
                        return;
                    // keep original class in global
                    _global[zoneSymbol(className)] = OriginalClass;
                    _global[className] = function () {
                        var a = bindArguments(arguments, className);
                        switch (a.length) {
                            case 0:
                                this[originalInstanceKey] = new OriginalClass();
                                break;
                            case 1:
                                this[originalInstanceKey] = new OriginalClass(a[0]);
                                break;
                            case 2:
                                this[originalInstanceKey] = new OriginalClass(a[0], a[1]);
                                break;
                            case 3:
                                this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                                break;
                            case 4:
                                this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                                break;
                            default:
                                throw new Error('Arg list too long.');
                        }
                    };
                    // attach original delegate to patched function
                    attachOriginToPatched(_global[className], OriginalClass);
                    var instance = new OriginalClass(function () { });
                    var prop;
                    for (prop in instance) {
                        // https://bugs.webkit.org/show_bug.cgi?id=44721
                        if (className === 'XMLHttpRequest' && prop === 'responseBlob')
                            continue;
                        (function (prop) {
                            if (typeof instance[prop] === 'function') {
                                _global[className].prototype[prop] = function () {
                                    return this[originalInstanceKey][prop].apply(this[originalInstanceKey], arguments);
                                };
                            }
                            else {
                                ObjectDefineProperty(_global[className].prototype, prop, {
                                    set: function (fn) {
                                        if (typeof fn === 'function') {
                                            this[originalInstanceKey][prop] = wrapWithCurrentZone(fn, className + '.' + prop);
                                            // keep callback in wrapped function so we can
                                            // use it in Function.prototype.toString to return
                                            // the native one.
                                            attachOriginToPatched(this[originalInstanceKey][prop], fn);
                                        }
                                        else {
                                            this[originalInstanceKey][prop] = fn;
                                        }
                                    },
                                    get: function () { return this[originalInstanceKey][prop]; }
                                });
                            }
                        }(prop));
                    }
                    for (prop in OriginalClass) {
                        if (prop !== 'prototype' && OriginalClass.hasOwnProperty(prop)) {
                            _global[className][prop] = OriginalClass[prop];
                        }
                    }
                }
                function copySymbolProperties(src, dest) {
                    if (typeof Object.getOwnPropertySymbols !== 'function') {
                        return;
                    }
                    var symbols = Object.getOwnPropertySymbols(src);
                    symbols.forEach(function (symbol) {
                        var desc = Object.getOwnPropertyDescriptor(src, symbol);
                        Object.defineProperty(dest, symbol, {
                            get: function () { return src[symbol]; },
                            set: function (value) {
                                if (desc && (!desc.writable || typeof desc.set !== 'function')) {
                                    // if src[symbol] is not writable or not have a setter, just return
                                    return;
                                }
                                src[symbol] = value;
                            },
                            enumerable: desc ? desc.enumerable : true,
                            configurable: desc ? desc.configurable : true
                        });
                    });
                }
                var shouldCopySymbolProperties = false;
                function patchMethod(target, name, patchFn) {
                    var proto = target;
                    while (proto && !proto.hasOwnProperty(name)) {
                        proto = ObjectGetPrototypeOf(proto);
                    }
                    if (!proto && target[name]) {
                        // somehow we did not find it, but we can see it. This happens on IE for Window properties.
                        proto = target;
                    }
                    var delegateName = zoneSymbol(name);
                    var delegate = null;
                    if (proto && !(delegate = proto[delegateName])) {
                        delegate = proto[delegateName] = proto[name];
                        // check whether proto[name] is writable
                        // some property is readonly in safari, such as HtmlCanvasElement.prototype.toBlob
                        var desc = proto && ObjectGetOwnPropertyDescriptor(proto, name);
                        if (isPropertyWritable(desc)) {
                            var patchDelegate_1 = patchFn(delegate, delegateName, name);
                            proto[name] = function () { return patchDelegate_1(this, arguments); };
                            attachOriginToPatched(proto[name], delegate);
                            if (shouldCopySymbolProperties) {
                                copySymbolProperties(delegate, proto[name]);
                            }
                        }
                    }
                    return delegate;
                }
                // TODO: @JiaLiPassion, support cancel task later if necessary
                function patchMacroTask(obj, funcName, metaCreator) {
                    var setNative = null;
                    function scheduleTask(task) {
                        var data = task.data;
                        data.args[data.cbIdx] = function () { task.invoke.apply(this, arguments); };
                        setNative.apply(data.target, data.args);
                        return task;
                    }
                    setNative = patchMethod(obj, funcName, function (delegate) { return function (self, args) {
                        var meta = metaCreator(self, args);
                        if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === 'function') {
                            return scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
                        }
                        else {
                            // cause an error by calling it directly.
                            return delegate.apply(self, args);
                        }
                    }; });
                }
                function attachOriginToPatched(patched, original) {
                    patched[zoneSymbol('OriginalDelegate')] = original;
                }
                var isDetectedIEOrEdge = false;
                var ieOrEdge = false;
                function isIE() {
                    try {
                        var ua = internalWindow.navigator.userAgent;
                        if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1) {
                            return true;
                        }
                    }
                    catch (error) {
                    }
                    return false;
                }
                function isIEOrEdge() {
                    if (isDetectedIEOrEdge) {
                        return ieOrEdge;
                    }
                    isDetectedIEOrEdge = true;
                    try {
                        var ua = internalWindow.navigator.userAgent;
                        if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1 || ua.indexOf('Edge/') !== -1) {
                            ieOrEdge = true;
                        }
                    }
                    catch (error) {
                    }
                    return ieOrEdge;
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                // override Function.prototype.toString to make zone.js patched function
                // look like native function
                Zone.__load_patch('toString', function (global) {
                    // patch Func.prototype.toString to let them look like native
                    var originalFunctionToString = Function.prototype.toString;
                    var ORIGINAL_DELEGATE_SYMBOL = zoneSymbol('OriginalDelegate');
                    var PROMISE_SYMBOL = zoneSymbol('Promise');
                    var ERROR_SYMBOL = zoneSymbol('Error');
                    var newFunctionToString = function toString() {
                        if (typeof this === 'function') {
                            var originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                            if (originalDelegate) {
                                if (typeof originalDelegate === 'function') {
                                    return originalFunctionToString.call(originalDelegate);
                                }
                                else {
                                    return Object.prototype.toString.call(originalDelegate);
                                }
                            }
                            if (this === Promise) {
                                var nativePromise = global[PROMISE_SYMBOL];
                                if (nativePromise) {
                                    return originalFunctionToString.call(nativePromise);
                                }
                            }
                            if (this === Error) {
                                var nativeError = global[ERROR_SYMBOL];
                                if (nativeError) {
                                    return originalFunctionToString.call(nativeError);
                                }
                            }
                        }
                        return originalFunctionToString.call(this);
                    };
                    newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
                    Function.prototype.toString = newFunctionToString;
                    // patch Object.prototype.toString to let them look like native
                    var originalObjectToString = Object.prototype.toString;
                    var PROMISE_OBJECT_TO_STRING = '[object Promise]';
                    Object.prototype.toString = function () {
                        if (this instanceof Promise) {
                            return PROMISE_OBJECT_TO_STRING;
                        }
                        return originalObjectToString.call(this);
                    };
                });
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                var passiveSupported = false;
                if (typeof window !== 'undefined') {
                    try {
                        var options = Object.defineProperty({}, 'passive', { get: function () { passiveSupported = true; } });
                        window.addEventListener('test', options, options);
                        window.removeEventListener('test', options, options);
                    }
                    catch (err) {
                        passiveSupported = false;
                    }
                }
                // an identifier to tell ZoneTask do not create a new invoke closure
                var OPTIMIZED_ZONE_EVENT_TASK_DATA = {
                    useG: true
                };
                var zoneSymbolEventNames$1 = {};
                var globalSources = {};
                var EVENT_NAME_SYMBOL_REGX = new RegExp('^' + ZONE_SYMBOL_PREFIX + '(\\w+)(true|false)$');
                var IMMEDIATE_PROPAGATION_SYMBOL = zoneSymbol('propagationStopped');
                function patchEventTarget(_global, apis, patchOptions) {
                    var ADD_EVENT_LISTENER = (patchOptions && patchOptions.add) || ADD_EVENT_LISTENER_STR;
                    var REMOVE_EVENT_LISTENER = (patchOptions && patchOptions.rm) || REMOVE_EVENT_LISTENER_STR;
                    var LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.listeners) || 'eventListeners';
                    var REMOVE_ALL_LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.rmAll) || 'removeAllListeners';
                    var zoneSymbolAddEventListener = zoneSymbol(ADD_EVENT_LISTENER);
                    var ADD_EVENT_LISTENER_SOURCE = '.' + ADD_EVENT_LISTENER + ':';
                    var PREPEND_EVENT_LISTENER = 'prependListener';
                    var PREPEND_EVENT_LISTENER_SOURCE = '.' + PREPEND_EVENT_LISTENER + ':';
                    var invokeTask = function (task, target, event) {
                        // for better performance, check isRemoved which is set
                        // by removeEventListener
                        if (task.isRemoved) {
                            return;
                        }
                        var delegate = task.callback;
                        if (typeof delegate === 'object' && delegate.handleEvent) {
                            // create the bind version of handleEvent when invoke
                            task.callback = function (event) { return delegate.handleEvent(event); };
                            task.originalDelegate = delegate;
                        }
                        // invoke static task.invoke
                        task.invoke(task, target, [event]);
                        var options = task.options;
                        if (options && typeof options === 'object' && options.once) {
                            // if options.once is true, after invoke once remove listener here
                            // only browser need to do this, nodejs eventEmitter will cal removeListener
                            // inside EventEmitter.once
                            var delegate_1 = task.originalDelegate ? task.originalDelegate : task.callback;
                            target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate_1, options);
                        }
                    };
                    // global shared zoneAwareCallback to handle all event callback with capture = false
                    var globalZoneAwareCallback = function (event) {
                        // https://github.com/angular/zone.js/issues/911, in IE, sometimes
                        // event will be undefined, so we need to use window.event
                        event = event || _global.event;
                        if (!event) {
                            return;
                        }
                        // event.target is needed for Samsung TV and SourceBuffer
                        // || global is needed https://github.com/angular/zone.js/issues/190
                        var target = this || event.target || _global;
                        var tasks = target[zoneSymbolEventNames$1[event.type][FALSE_STR]];
                        if (tasks) {
                            // invoke all tasks which attached to current target with given event.type and capture = false
                            // for performance concern, if task.length === 1, just invoke
                            if (tasks.length === 1) {
                                invokeTask(tasks[0], target, event);
                            }
                            else {
                                // https://github.com/angular/zone.js/issues/836
                                // copy the tasks array before invoke, to avoid
                                // the callback will remove itself or other listener
                                var copyTasks = tasks.slice();
                                for (var i = 0; i < copyTasks.length; i++) {
                                    if (event && event[IMMEDIATE_PROPAGATION_SYMBOL] === true) {
                                        break;
                                    }
                                    invokeTask(copyTasks[i], target, event);
                                }
                            }
                        }
                    };
                    // global shared zoneAwareCallback to handle all event callback with capture = true
                    var globalZoneAwareCaptureCallback = function (event) {
                        // https://github.com/angular/zone.js/issues/911, in IE, sometimes
                        // event will be undefined, so we need to use window.event
                        event = event || _global.event;
                        if (!event) {
                            return;
                        }
                        // event.target is needed for Samsung TV and SourceBuffer
                        // || global is needed https://github.com/angular/zone.js/issues/190
                        var target = this || event.target || _global;
                        var tasks = target[zoneSymbolEventNames$1[event.type][TRUE_STR]];
                        if (tasks) {
                            // invoke all tasks which attached to current target with given event.type and capture = false
                            // for performance concern, if task.length === 1, just invoke
                            if (tasks.length === 1) {
                                invokeTask(tasks[0], target, event);
                            }
                            else {
                                // https://github.com/angular/zone.js/issues/836
                                // copy the tasks array before invoke, to avoid
                                // the callback will remove itself or other listener
                                var copyTasks = tasks.slice();
                                for (var i = 0; i < copyTasks.length; i++) {
                                    if (event && event[IMMEDIATE_PROPAGATION_SYMBOL] === true) {
                                        break;
                                    }
                                    invokeTask(copyTasks[i], target, event);
                                }
                            }
                        }
                    };
                    function patchEventTargetMethods(obj, patchOptions) {
                        if (!obj) {
                            return false;
                        }
                        var useGlobalCallback = true;
                        if (patchOptions && patchOptions.useG !== undefined) {
                            useGlobalCallback = patchOptions.useG;
                        }
                        var validateHandler = patchOptions && patchOptions.vh;
                        var checkDuplicate = true;
                        if (patchOptions && patchOptions.chkDup !== undefined) {
                            checkDuplicate = patchOptions.chkDup;
                        }
                        var returnTarget = false;
                        if (patchOptions && patchOptions.rt !== undefined) {
                            returnTarget = patchOptions.rt;
                        }
                        var proto = obj;
                        while (proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER)) {
                            proto = ObjectGetPrototypeOf(proto);
                        }
                        if (!proto && obj[ADD_EVENT_LISTENER]) {
                            // somehow we did not find it, but we can see it. This happens on IE for Window properties.
                            proto = obj;
                        }
                        if (!proto) {
                            return false;
                        }
                        if (proto[zoneSymbolAddEventListener]) {
                            return false;
                        }
                        var eventNameToString = patchOptions && patchOptions.eventNameToString;
                        // a shared global taskData to pass data for scheduleEventTask
                        // so we do not need to create a new object just for pass some data
                        var taskData = {};
                        var nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
                        var nativeRemoveEventListener = proto[zoneSymbol(REMOVE_EVENT_LISTENER)] =
                            proto[REMOVE_EVENT_LISTENER];
                        var nativeListeners = proto[zoneSymbol(LISTENERS_EVENT_LISTENER)] =
                            proto[LISTENERS_EVENT_LISTENER];
                        var nativeRemoveAllListeners = proto[zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] =
                            proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
                        var nativePrependEventListener;
                        if (patchOptions && patchOptions.prepend) {
                            nativePrependEventListener = proto[zoneSymbol(patchOptions.prepend)] =
                                proto[patchOptions.prepend];
                        }
                        function checkIsPassive(task) {
                            if (!passiveSupported && typeof taskData.options !== 'boolean' &&
                                typeof taskData.options !== 'undefined' && taskData.options !== null) {
                                // options is a non-null non-undefined object
                                // passive is not supported
                                // don't pass options as object
                                // just pass capture as a boolean
                                task.options = !!taskData.options.capture;
                                taskData.options = task.options;
                            }
                        }
                        var customScheduleGlobal = function (task) {
                            // if there is already a task for the eventName + capture,
                            // just return, because we use the shared globalZoneAwareCallback here.
                            if (taskData.isExisting) {
                                return;
                            }
                            checkIsPassive(task);
                            return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
                        };
                        var customCancelGlobal = function (task) {
                            // if task is not marked as isRemoved, this call is directly
                            // from Zone.prototype.cancelTask, we should remove the task
                            // from tasksList of target first
                            if (!task.isRemoved) {
                                var symbolEventNames = zoneSymbolEventNames$1[task.eventName];
                                var symbolEventName = void 0;
                                if (symbolEventNames) {
                                    symbolEventName = symbolEventNames[task.capture ? TRUE_STR : FALSE_STR];
                                }
                                var existingTasks = symbolEventName && task.target[symbolEventName];
                                if (existingTasks) {
                                    for (var i = 0; i < existingTasks.length; i++) {
                                        var existingTask = existingTasks[i];
                                        if (existingTask === task) {
                                            existingTasks.splice(i, 1);
                                            // set isRemoved to data for faster invokeTask check
                                            task.isRemoved = true;
                                            if (existingTasks.length === 0) {
                                                // all tasks for the eventName + capture have gone,
                                                // remove globalZoneAwareCallback and remove the task cache from target
                                                task.allRemoved = true;
                                                task.target[symbolEventName] = null;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            // if all tasks for the eventName + capture have gone,
                            // we will really remove the global event callback,
                            // if not, return
                            if (!task.allRemoved) {
                                return;
                            }
                            return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
                        };
                        var customScheduleNonGlobal = function (task) {
                            checkIsPassive(task);
                            return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
                        };
                        var customSchedulePrepend = function (task) {
                            return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
                        };
                        var customCancelNonGlobal = function (task) {
                            return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
                        };
                        var customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
                        var customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
                        var compareTaskCallbackVsDelegate = function (task, delegate) {
                            var typeOfDelegate = typeof delegate;
                            return (typeOfDelegate === 'function' && task.callback === delegate) ||
                                (typeOfDelegate === 'object' && task.originalDelegate === delegate);
                        };
                        var compare = (patchOptions && patchOptions.diff) ? patchOptions.diff : compareTaskCallbackVsDelegate;
                        var blackListedEvents = Zone[zoneSymbol('BLACK_LISTED_EVENTS')];
                        var makeAddListener = function (nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget, prepend) {
                            if (returnTarget === void 0) { returnTarget = false; }
                            if (prepend === void 0) { prepend = false; }
                            return function () {
                                var target = this || _global;
                                var eventName = arguments[0];
                                if (patchOptions && patchOptions.transferEventName) {
                                    eventName = patchOptions.transferEventName(eventName);
                                }
                                var delegate = arguments[1];
                                if (!delegate) {
                                    return nativeListener.apply(this, arguments);
                                }
                                if (isNode && eventName === 'uncaughtException') {
                                    // don't patch uncaughtException of nodejs to prevent endless loop
                                    return nativeListener.apply(this, arguments);
                                }
                                // don't create the bind delegate function for handleEvent
                                // case here to improve addEventListener performance
                                // we will create the bind delegate when invoke
                                var isHandleEvent = false;
                                if (typeof delegate !== 'function') {
                                    if (!delegate.handleEvent) {
                                        return nativeListener.apply(this, arguments);
                                    }
                                    isHandleEvent = true;
                                }
                                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) {
                                    return;
                                }
                                var options = arguments[2];
                                if (blackListedEvents) {
                                    // check black list
                                    for (var i = 0; i < blackListedEvents.length; i++) {
                                        if (eventName === blackListedEvents[i]) {
                                            return nativeListener.apply(this, arguments);
                                        }
                                    }
                                }
                                var capture;
                                var once = false;
                                if (options === undefined) {
                                    capture = false;
                                }
                                else if (options === true) {
                                    capture = true;
                                }
                                else if (options === false) {
                                    capture = false;
                                }
                                else {
                                    capture = options ? !!options.capture : false;
                                    once = options ? !!options.once : false;
                                }
                                var zone = Zone.current;
                                var symbolEventNames = zoneSymbolEventNames$1[eventName];
                                var symbolEventName;
                                if (!symbolEventNames) {
                                    // the code is duplicate, but I just want to get some better performance
                                    var falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + FALSE_STR;
                                    var trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + TRUE_STR;
                                    var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
                                    var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
                                    zoneSymbolEventNames$1[eventName] = {};
                                    zoneSymbolEventNames$1[eventName][FALSE_STR] = symbol;
                                    zoneSymbolEventNames$1[eventName][TRUE_STR] = symbolCapture;
                                    symbolEventName = capture ? symbolCapture : symbol;
                                }
                                else {
                                    symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
                                }
                                var existingTasks = target[symbolEventName];
                                var isExisting = false;
                                if (existingTasks) {
                                    // already have task registered
                                    isExisting = true;
                                    if (checkDuplicate) {
                                        for (var i = 0; i < existingTasks.length; i++) {
                                            if (compare(existingTasks[i], delegate)) {
                                                // same callback, same capture, same event name, just return
                                                return;
                                            }
                                        }
                                    }
                                }
                                else {
                                    existingTasks = target[symbolEventName] = [];
                                }
                                var source;
                                var constructorName = target.constructor['name'];
                                var targetSource = globalSources[constructorName];
                                if (targetSource) {
                                    source = targetSource[eventName];
                                }
                                if (!source) {
                                    source = constructorName + addSource +
                                        (eventNameToString ? eventNameToString(eventName) : eventName);
                                }
                                // do not create a new object as task.data to pass those things
                                // just use the global shared one
                                taskData.options = options;
                                if (once) {
                                    // if addEventListener with once options, we don't pass it to
                                    // native addEventListener, instead we keep the once setting
                                    // and handle ourselves.
                                    taskData.options.once = false;
                                }
                                taskData.target = target;
                                taskData.capture = capture;
                                taskData.eventName = eventName;
                                taskData.isExisting = isExisting;
                                var data = useGlobalCallback ? OPTIMIZED_ZONE_EVENT_TASK_DATA : undefined;
                                // keep taskData into data to allow onScheduleEventTask to access the task information
                                if (data) {
                                    data.taskData = taskData;
                                }
                                var task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                                // should clear taskData.target to avoid memory leak
                                // issue, https://github.com/angular/angular/issues/20442
                                taskData.target = null;
                                // need to clear up taskData because it is a global object
                                if (data) {
                                    data.taskData = null;
                                }
                                // have to save those information to task in case
                                // application may call task.zone.cancelTask() directly
                                if (once) {
                                    options.once = true;
                                }
                                if (!(!passiveSupported && typeof task.options === 'boolean')) {
                                    // if not support passive, and we pass an option object
                                    // to addEventListener, we should save the options to task
                                    task.options = options;
                                }
                                task.target = target;
                                task.capture = capture;
                                task.eventName = eventName;
                                if (isHandleEvent) {
                                    // save original delegate for compare to check duplicate
                                    task.originalDelegate = delegate;
                                }
                                if (!prepend) {
                                    existingTasks.push(task);
                                }
                                else {
                                    existingTasks.unshift(task);
                                }
                                if (returnTarget) {
                                    return target;
                                }
                            };
                        };
                        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
                        if (nativePrependEventListener) {
                            proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
                        }
                        proto[REMOVE_EVENT_LISTENER] = function () {
                            var target = this || _global;
                            var eventName = arguments[0];
                            if (patchOptions && patchOptions.transferEventName) {
                                eventName = patchOptions.transferEventName(eventName);
                            }
                            var options = arguments[2];
                            var capture;
                            if (options === undefined) {
                                capture = false;
                            }
                            else if (options === true) {
                                capture = true;
                            }
                            else if (options === false) {
                                capture = false;
                            }
                            else {
                                capture = options ? !!options.capture : false;
                            }
                            var delegate = arguments[1];
                            if (!delegate) {
                                return nativeRemoveEventListener.apply(this, arguments);
                            }
                            if (validateHandler &&
                                !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) {
                                return;
                            }
                            var symbolEventNames = zoneSymbolEventNames$1[eventName];
                            var symbolEventName;
                            if (symbolEventNames) {
                                symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
                            }
                            var existingTasks = symbolEventName && target[symbolEventName];
                            if (existingTasks) {
                                for (var i = 0; i < existingTasks.length; i++) {
                                    var existingTask = existingTasks[i];
                                    if (compare(existingTask, delegate)) {
                                        existingTasks.splice(i, 1);
                                        // set isRemoved to data for faster invokeTask check
                                        existingTask.isRemoved = true;
                                        if (existingTasks.length === 0) {
                                            // all tasks for the eventName + capture have gone,
                                            // remove globalZoneAwareCallback and remove the task cache from target
                                            existingTask.allRemoved = true;
                                            target[symbolEventName] = null;
                                            // in the target, we have an event listener which is added by on_property
                                            // such as target.onclick = function() {}, so we need to clear this internal
                                            // property too if all delegates all removed
                                            if (typeof eventName === 'string') {
                                                var onPropertySymbol = ZONE_SYMBOL_PREFIX + 'ON_PROPERTY' + eventName;
                                                target[onPropertySymbol] = null;
                                            }
                                        }
                                        existingTask.zone.cancelTask(existingTask);
                                        if (returnTarget) {
                                            return target;
                                        }
                                        return;
                                    }
                                }
                            }
                            // issue 930, didn't find the event name or callback
                            // from zone kept existingTasks, the callback maybe
                            // added outside of zone, we need to call native removeEventListener
                            // to try to remove it.
                            return nativeRemoveEventListener.apply(this, arguments);
                        };
                        proto[LISTENERS_EVENT_LISTENER] = function () {
                            var target = this || _global;
                            var eventName = arguments[0];
                            if (patchOptions && patchOptions.transferEventName) {
                                eventName = patchOptions.transferEventName(eventName);
                            }
                            var listeners = [];
                            var tasks = findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
                            for (var i = 0; i < tasks.length; i++) {
                                var task = tasks[i];
                                var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                                listeners.push(delegate);
                            }
                            return listeners;
                        };
                        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function () {
                            var target = this || _global;
                            var eventName = arguments[0];
                            if (!eventName) {
                                var keys = Object.keys(target);
                                for (var i = 0; i < keys.length; i++) {
                                    var prop = keys[i];
                                    var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
                                    var evtName = match && match[1];
                                    // in nodejs EventEmitter, removeListener event is
                                    // used for monitoring the removeListener call,
                                    // so just keep removeListener eventListener until
                                    // all other eventListeners are removed
                                    if (evtName && evtName !== 'removeListener') {
                                        this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                                    }
                                }
                                // remove removeListener listener finally
                                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, 'removeListener');
                            }
                            else {
                                if (patchOptions && patchOptions.transferEventName) {
                                    eventName = patchOptions.transferEventName(eventName);
                                }
                                var symbolEventNames = zoneSymbolEventNames$1[eventName];
                                if (symbolEventNames) {
                                    var symbolEventName = symbolEventNames[FALSE_STR];
                                    var symbolCaptureEventName = symbolEventNames[TRUE_STR];
                                    var tasks = target[symbolEventName];
                                    var captureTasks = target[symbolCaptureEventName];
                                    if (tasks) {
                                        var removeTasks = tasks.slice();
                                        for (var i = 0; i < removeTasks.length; i++) {
                                            var task = removeTasks[i];
                                            var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                                        }
                                    }
                                    if (captureTasks) {
                                        var removeTasks = captureTasks.slice();
                                        for (var i = 0; i < removeTasks.length; i++) {
                                            var task = removeTasks[i];
                                            var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                                        }
                                    }
                                }
                            }
                            if (returnTarget) {
                                return this;
                            }
                        };
                        // for native toString patch
                        attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
                        attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
                        if (nativeRemoveAllListeners) {
                            attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
                        }
                        if (nativeListeners) {
                            attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
                        }
                        return true;
                    }
                    var results = [];
                    for (var i = 0; i < apis.length; i++) {
                        results[i] = patchEventTargetMethods(apis[i], patchOptions);
                    }
                    return results;
                }
                function findEventTasks(target, eventName) {
                    var foundTasks = [];
                    for (var prop in target) {
                        var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
                        var evtName = match && match[1];
                        if (evtName && (!eventName || evtName === eventName)) {
                            var tasks = target[prop];
                            if (tasks) {
                                for (var i = 0; i < tasks.length; i++) {
                                    foundTasks.push(tasks[i]);
                                }
                            }
                        }
                    }
                    return foundTasks;
                }
                function patchEventPrototype(global, api) {
                    var Event = global['Event'];
                    if (Event && Event.prototype) {
                        api.patchMethod(Event.prototype, 'stopImmediatePropagation', function (delegate) { return function (self, args) {
                            self[IMMEDIATE_PROPAGATION_SYMBOL] = true;
                            // we need to call the native stopImmediatePropagation
                            // in case in some hybrid application, some part of
                            // application will be controlled by zone, some are not
                            delegate && delegate.apply(self, args);
                        }; });
                    }
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                function patchCallbacks(api, target, targetName, method, callbacks) {
                    var symbol = Zone.__symbol__(method);
                    if (target[symbol]) {
                        return;
                    }
                    var nativeDelegate = target[symbol] = target[method];
                    target[method] = function (name, opts, options) {
                        if (opts && opts.prototype) {
                            callbacks.forEach(function (callback) {
                                var source = targetName + "." + method + "::" + callback;
                                var prototype = opts.prototype;
                                if (prototype.hasOwnProperty(callback)) {
                                    var descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                                    if (descriptor && descriptor.value) {
                                        descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                                        api._redefineProperty(opts.prototype, callback, descriptor);
                                    }
                                    else if (prototype[callback]) {
                                        prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                                    }
                                }
                                else if (prototype[callback]) {
                                    prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                                }
                            });
                        }
                        return nativeDelegate.call(target, name, opts, options);
                    };
                    api.attachOriginToPatched(target[method], nativeDelegate);
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                var globalEventHandlersEventNames = [
                    'abort',
                    'animationcancel',
                    'animationend',
                    'animationiteration',
                    'auxclick',
                    'beforeinput',
                    'blur',
                    'cancel',
                    'canplay',
                    'canplaythrough',
                    'change',
                    'compositionstart',
                    'compositionupdate',
                    'compositionend',
                    'cuechange',
                    'click',
                    'close',
                    'contextmenu',
                    'curechange',
                    'dblclick',
                    'drag',
                    'dragend',
                    'dragenter',
                    'dragexit',
                    'dragleave',
                    'dragover',
                    'drop',
                    'durationchange',
                    'emptied',
                    'ended',
                    'error',
                    'focus',
                    'focusin',
                    'focusout',
                    'gotpointercapture',
                    'input',
                    'invalid',
                    'keydown',
                    'keypress',
                    'keyup',
                    'load',
                    'loadstart',
                    'loadeddata',
                    'loadedmetadata',
                    'lostpointercapture',
                    'mousedown',
                    'mouseenter',
                    'mouseleave',
                    'mousemove',
                    'mouseout',
                    'mouseover',
                    'mouseup',
                    'mousewheel',
                    'orientationchange',
                    'pause',
                    'play',
                    'playing',
                    'pointercancel',
                    'pointerdown',
                    'pointerenter',
                    'pointerleave',
                    'pointerlockchange',
                    'mozpointerlockchange',
                    'webkitpointerlockerchange',
                    'pointerlockerror',
                    'mozpointerlockerror',
                    'webkitpointerlockerror',
                    'pointermove',
                    'pointout',
                    'pointerover',
                    'pointerup',
                    'progress',
                    'ratechange',
                    'reset',
                    'resize',
                    'scroll',
                    'seeked',
                    'seeking',
                    'select',
                    'selectionchange',
                    'selectstart',
                    'show',
                    'sort',
                    'stalled',
                    'submit',
                    'suspend',
                    'timeupdate',
                    'volumechange',
                    'touchcancel',
                    'touchmove',
                    'touchstart',
                    'touchend',
                    'transitioncancel',
                    'transitionend',
                    'waiting',
                    'wheel'
                ];
                var documentEventNames = [
                    'afterscriptexecute', 'beforescriptexecute', 'DOMContentLoaded', 'freeze', 'fullscreenchange',
                    'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange', 'fullscreenerror',
                    'mozfullscreenerror', 'webkitfullscreenerror', 'msfullscreenerror', 'readystatechange',
                    'visibilitychange', 'resume'
                ];
                var windowEventNames = [
                    'absolutedeviceorientation',
                    'afterinput',
                    'afterprint',
                    'appinstalled',
                    'beforeinstallprompt',
                    'beforeprint',
                    'beforeunload',
                    'devicelight',
                    'devicemotion',
                    'deviceorientation',
                    'deviceorientationabsolute',
                    'deviceproximity',
                    'hashchange',
                    'languagechange',
                    'message',
                    'mozbeforepaint',
                    'offline',
                    'online',
                    'paint',
                    'pageshow',
                    'pagehide',
                    'popstate',
                    'rejectionhandled',
                    'storage',
                    'unhandledrejection',
                    'unload',
                    'userproximity',
                    'vrdisplyconnected',
                    'vrdisplaydisconnected',
                    'vrdisplaypresentchange'
                ];
                var htmlElementEventNames = [
                    'beforecopy', 'beforecut', 'beforepaste', 'copy', 'cut', 'paste', 'dragstart', 'loadend',
                    'animationstart', 'search', 'transitionrun', 'transitionstart', 'webkitanimationend',
                    'webkitanimationiteration', 'webkitanimationstart', 'webkittransitionend'
                ];
                var mediaElementEventNames = ['encrypted', 'waitingforkey', 'msneedkey', 'mozinterruptbegin', 'mozinterruptend'];
                var ieElementEventNames = [
                    'activate',
                    'afterupdate',
                    'ariarequest',
                    'beforeactivate',
                    'beforedeactivate',
                    'beforeeditfocus',
                    'beforeupdate',
                    'cellchange',
                    'controlselect',
                    'dataavailable',
                    'datasetchanged',
                    'datasetcomplete',
                    'errorupdate',
                    'filterchange',
                    'layoutcomplete',
                    'losecapture',
                    'move',
                    'moveend',
                    'movestart',
                    'propertychange',
                    'resizeend',
                    'resizestart',
                    'rowenter',
                    'rowexit',
                    'rowsdelete',
                    'rowsinserted',
                    'command',
                    'compassneedscalibration',
                    'deactivate',
                    'help',
                    'mscontentzoom',
                    'msmanipulationstatechanged',
                    'msgesturechange',
                    'msgesturedoubletap',
                    'msgestureend',
                    'msgesturehold',
                    'msgesturestart',
                    'msgesturetap',
                    'msgotpointercapture',
                    'msinertiastart',
                    'mslostpointercapture',
                    'mspointercancel',
                    'mspointerdown',
                    'mspointerenter',
                    'mspointerhover',
                    'mspointerleave',
                    'mspointermove',
                    'mspointerout',
                    'mspointerover',
                    'mspointerup',
                    'pointerout',
                    'mssitemodejumplistitemremoved',
                    'msthumbnailclick',
                    'stop',
                    'storagecommit'
                ];
                var webglEventNames = ['webglcontextrestored', 'webglcontextlost', 'webglcontextcreationerror'];
                var formEventNames = ['autocomplete', 'autocompleteerror'];
                var detailEventNames = ['toggle'];
                var frameEventNames = ['load'];
                var frameSetEventNames = ['blur', 'error', 'focus', 'load', 'resize', 'scroll', 'messageerror'];
                var marqueeEventNames = ['bounce', 'finish', 'start'];
                var XMLHttpRequestEventNames = [
                    'loadstart', 'progress', 'abort', 'error', 'load', 'progress', 'timeout', 'loadend',
                    'readystatechange'
                ];
                var IDBIndexEventNames = ['upgradeneeded', 'complete', 'abort', 'success', 'error', 'blocked', 'versionchange', 'close'];
                var websocketEventNames = ['close', 'error', 'open', 'message'];
                var workerEventNames = ['error', 'message'];
                var eventNames = globalEventHandlersEventNames.concat(webglEventNames, formEventNames, detailEventNames, documentEventNames, windowEventNames, htmlElementEventNames, ieElementEventNames);
                function filterProperties(target, onProperties, ignoreProperties) {
                    if (!ignoreProperties || ignoreProperties.length === 0) {
                        return onProperties;
                    }
                    var tip = ignoreProperties.filter(function (ip) { return ip.target === target; });
                    if (!tip || tip.length === 0) {
                        return onProperties;
                    }
                    var targetIgnoreProperties = tip[0].ignoreProperties;
                    return onProperties.filter(function (op) { return targetIgnoreProperties.indexOf(op) === -1; });
                }
                function patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
                    // check whether target is available, sometimes target will be undefined
                    // because different browser or some 3rd party plugin.
                    if (!target) {
                        return;
                    }
                    var filteredProperties = filterProperties(target, onProperties, ignoreProperties);
                    patchOnProperties(target, filteredProperties, prototype);
                }
                function propertyDescriptorPatch(api, _global) {
                    if (isNode && !isMix) {
                        return;
                    }
                    if (Zone[api.symbol('patchEvents')]) {
                        // events are already been patched by legacy patch.
                        return;
                    }
                    var supportsWebSocket = typeof WebSocket !== 'undefined';
                    var ignoreProperties = _global['__Zone_ignore_on_properties'];
                    // for browsers that we can patch the descriptor:  Chrome & Firefox
                    if (isBrowser) {
                        var internalWindow_1 = window;
                        var ignoreErrorProperties = isIE ? [{ target: internalWindow_1, ignoreProperties: ['error'] }] : [];
                        // in IE/Edge, onProp not exist in window object, but in WindowPrototype
                        // so we need to pass WindowPrototype to check onProp exist or not
                        patchFilteredProperties(internalWindow_1, eventNames.concat(['messageerror']), ignoreProperties ? ignoreProperties.concat(ignoreErrorProperties) : ignoreProperties, ObjectGetPrototypeOf(internalWindow_1));
                        patchFilteredProperties(Document.prototype, eventNames, ignoreProperties);
                        if (typeof internalWindow_1['SVGElement'] !== 'undefined') {
                            patchFilteredProperties(internalWindow_1['SVGElement'].prototype, eventNames, ignoreProperties);
                        }
                        patchFilteredProperties(Element.prototype, eventNames, ignoreProperties);
                        patchFilteredProperties(HTMLElement.prototype, eventNames, ignoreProperties);
                        patchFilteredProperties(HTMLMediaElement.prototype, mediaElementEventNames, ignoreProperties);
                        patchFilteredProperties(HTMLFrameSetElement.prototype, windowEventNames.concat(frameSetEventNames), ignoreProperties);
                        patchFilteredProperties(HTMLBodyElement.prototype, windowEventNames.concat(frameSetEventNames), ignoreProperties);
                        patchFilteredProperties(HTMLFrameElement.prototype, frameEventNames, ignoreProperties);
                        patchFilteredProperties(HTMLIFrameElement.prototype, frameEventNames, ignoreProperties);
                        var HTMLMarqueeElement = internalWindow_1['HTMLMarqueeElement'];
                        if (HTMLMarqueeElement) {
                            patchFilteredProperties(HTMLMarqueeElement.prototype, marqueeEventNames, ignoreProperties);
                        }
                        var Worker = internalWindow_1['Worker'];
                        if (Worker) {
                            patchFilteredProperties(Worker.prototype, workerEventNames, ignoreProperties);
                        }
                    }
                    var XMLHttpRequest = _global['XMLHttpRequest'];
                    if (XMLHttpRequest) {
                        // XMLHttpRequest is not available in ServiceWorker, so we need to check here
                        patchFilteredProperties(XMLHttpRequest.prototype, XMLHttpRequestEventNames, ignoreProperties);
                    }
                    var XMLHttpRequestEventTarget = _global['XMLHttpRequestEventTarget'];
                    if (XMLHttpRequestEventTarget) {
                        patchFilteredProperties(XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype, XMLHttpRequestEventNames, ignoreProperties);
                    }
                    if (typeof IDBIndex !== 'undefined') {
                        patchFilteredProperties(IDBIndex.prototype, IDBIndexEventNames, ignoreProperties);
                        patchFilteredProperties(IDBRequest.prototype, IDBIndexEventNames, ignoreProperties);
                        patchFilteredProperties(IDBOpenDBRequest.prototype, IDBIndexEventNames, ignoreProperties);
                        patchFilteredProperties(IDBDatabase.prototype, IDBIndexEventNames, ignoreProperties);
                        patchFilteredProperties(IDBTransaction.prototype, IDBIndexEventNames, ignoreProperties);
                        patchFilteredProperties(IDBCursor.prototype, IDBIndexEventNames, ignoreProperties);
                    }
                    if (supportsWebSocket) {
                        patchFilteredProperties(WebSocket.prototype, websocketEventNames, ignoreProperties);
                    }
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                Zone.__load_patch('util', function (global, Zone, api) {
                    api.patchOnProperties = patchOnProperties;
                    api.patchMethod = patchMethod;
                    api.bindArguments = bindArguments;
                    api.patchMacroTask = patchMacroTask;
                    // In earlier version of zone.js (<0.9.0), we use env name `__zone_symbol__BLACK_LISTED_EVENTS` to
                    // define which events will not be patched by `Zone.js`.
                    // In newer version (>=0.9.0), we change the env name to `__zone_symbol__UNPATCHED_EVENTS` to keep
                    // the name consistent with angular repo.
                    // The  `__zone_symbol__BLACK_LISTED_EVENTS` is deprecated, but it is still be supported for
                    // backwards compatibility.
                    var SYMBOL_BLACK_LISTED_EVENTS = Zone.__symbol__('BLACK_LISTED_EVENTS');
                    var SYMBOL_UNPATCHED_EVENTS = Zone.__symbol__('UNPATCHED_EVENTS');
                    if (global[SYMBOL_UNPATCHED_EVENTS]) {
                        global[SYMBOL_BLACK_LISTED_EVENTS] = global[SYMBOL_UNPATCHED_EVENTS];
                    }
                    if (global[SYMBOL_BLACK_LISTED_EVENTS]) {
                        Zone[SYMBOL_BLACK_LISTED_EVENTS] = Zone[SYMBOL_UNPATCHED_EVENTS] =
                            global[SYMBOL_BLACK_LISTED_EVENTS];
                    }
                    api.patchEventPrototype = patchEventPrototype;
                    api.patchEventTarget = patchEventTarget;
                    api.isIEOrEdge = isIEOrEdge;
                    api.ObjectDefineProperty = ObjectDefineProperty;
                    api.ObjectGetOwnPropertyDescriptor = ObjectGetOwnPropertyDescriptor;
                    api.ObjectCreate = ObjectCreate;
                    api.ArraySlice = ArraySlice;
                    api.patchClass = patchClass;
                    api.wrapWithCurrentZone = wrapWithCurrentZone;
                    api.filterProperties = filterProperties;
                    api.attachOriginToPatched = attachOriginToPatched;
                    api._redefineProperty = Object.defineProperty;
                    api.patchCallbacks = patchCallbacks;
                    api.getGlobalObjects = function () { return ({ globalSources: globalSources, zoneSymbolEventNames: zoneSymbolEventNames$1, eventNames: eventNames, isBrowser: isBrowser, isMix: isMix, isNode: isNode, TRUE_STR: TRUE_STR,
                        FALSE_STR: FALSE_STR, ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX, ADD_EVENT_LISTENER_STR: ADD_EVENT_LISTENER_STR, REMOVE_EVENT_LISTENER_STR: REMOVE_EVENT_LISTENER_STR }); };
                });
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                var taskSymbol = zoneSymbol('zoneTask');
                function patchTimer(window, setName, cancelName, nameSuffix) {
                    var setNative = null;
                    var clearNative = null;
                    setName += nameSuffix;
                    cancelName += nameSuffix;
                    var tasksByHandleId = {};
                    function scheduleTask(task) {
                        var data = task.data;
                        function timer() {
                            try {
                                task.invoke.apply(this, arguments);
                            }
                            finally {
                                // issue-934, task will be cancelled
                                // even it is a periodic task such as
                                // setInterval
                                if (!(task.data && task.data.isPeriodic)) {
                                    if (typeof data.handleId === 'number') {
                                        // in non-nodejs env, we remove timerId
                                        // from local cache
                                        delete tasksByHandleId[data.handleId];
                                    }
                                    else if (data.handleId) {
                                        // Node returns complex objects as handleIds
                                        // we remove task reference from timer object
                                        data.handleId[taskSymbol] = null;
                                    }
                                }
                            }
                        }
                        data.args[0] = timer;
                        data.handleId = setNative.apply(window, data.args);
                        return task;
                    }
                    function clearTask(task) { return clearNative(task.data.handleId); }
                    setNative =
                        patchMethod(window, setName, function (delegate) { return function (self, args) {
                            if (typeof args[0] === 'function') {
                                var options = {
                                    isPeriodic: nameSuffix === 'Interval',
                                    delay: (nameSuffix === 'Timeout' || nameSuffix === 'Interval') ? args[1] || 0 :
                                        undefined,
                                    args: args
                                };
                                var task = scheduleMacroTaskWithCurrentZone(setName, args[0], options, scheduleTask, clearTask);
                                if (!task) {
                                    return task;
                                }
                                // Node.js must additionally support the ref and unref functions.
                                var handle = task.data.handleId;
                                if (typeof handle === 'number') {
                                    // for non nodejs env, we save handleId: task
                                    // mapping in local cache for clearTimeout
                                    tasksByHandleId[handle] = task;
                                }
                                else if (handle) {
                                    // for nodejs env, we save task
                                    // reference in timerId Object for clearTimeout
                                    handle[taskSymbol] = task;
                                }
                                // check whether handle is null, because some polyfill or browser
                                // may return undefined from setTimeout/setInterval/setImmediate/requestAnimationFrame
                                if (handle && handle.ref && handle.unref && typeof handle.ref === 'function' &&
                                    typeof handle.unref === 'function') {
                                    task.ref = handle.ref.bind(handle);
                                    task.unref = handle.unref.bind(handle);
                                }
                                if (typeof handle === 'number' || handle) {
                                    return handle;
                                }
                                return task;
                            }
                            else {
                                // cause an error by calling it directly.
                                return delegate.apply(window, args);
                            }
                        }; });
                    clearNative =
                        patchMethod(window, cancelName, function (delegate) { return function (self, args) {
                            var id = args[0];
                            var task;
                            if (typeof id === 'number') {
                                // non nodejs env.
                                task = tasksByHandleId[id];
                            }
                            else {
                                // nodejs env.
                                task = id && id[taskSymbol];
                                // other environments.
                                if (!task) {
                                    task = id;
                                }
                            }
                            if (task && typeof task.type === 'string') {
                                if (task.state !== 'notScheduled' &&
                                    (task.cancelFn && task.data.isPeriodic || task.runCount === 0)) {
                                    if (typeof id === 'number') {
                                        delete tasksByHandleId[id];
                                    }
                                    else if (id) {
                                        id[taskSymbol] = null;
                                    }
                                    // Do not cancel already canceled functions
                                    task.zone.cancelTask(task);
                                }
                            }
                            else {
                                // cause an error by calling it directly.
                                delegate.apply(window, args);
                            }
                        }; });
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                function patchCustomElements(_global, api) {
                    var _a = api.getGlobalObjects(), isBrowser = _a.isBrowser, isMix = _a.isMix;
                    if ((!isBrowser && !isMix) || !_global['customElements'] || !('customElements' in _global)) {
                        return;
                    }
                    var callbacks = ['connectedCallback', 'disconnectedCallback', 'adoptedCallback', 'attributeChangedCallback'];
                    api.patchCallbacks(api, _global.customElements, 'customElements', 'define', callbacks);
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                function eventTargetPatch(_global, api) {
                    if (Zone[api.symbol('patchEventTarget')]) {
                        // EventTarget is already patched.
                        return;
                    }
                    var _a = api.getGlobalObjects(), eventNames = _a.eventNames, zoneSymbolEventNames = _a.zoneSymbolEventNames, TRUE_STR = _a.TRUE_STR, FALSE_STR = _a.FALSE_STR, ZONE_SYMBOL_PREFIX = _a.ZONE_SYMBOL_PREFIX;
                    //  predefine all __zone_symbol__ + eventName + true/false string
                    for (var i = 0; i < eventNames.length; i++) {
                        var eventName = eventNames[i];
                        var falseEventName = eventName + FALSE_STR;
                        var trueEventName = eventName + TRUE_STR;
                        var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
                        var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
                        zoneSymbolEventNames[eventName] = {};
                        zoneSymbolEventNames[eventName][FALSE_STR] = symbol;
                        zoneSymbolEventNames[eventName][TRUE_STR] = symbolCapture;
                    }
                    var EVENT_TARGET = _global['EventTarget'];
                    if (!EVENT_TARGET || !EVENT_TARGET.prototype) {
                        return;
                    }
                    api.patchEventTarget(_global, [EVENT_TARGET && EVENT_TARGET.prototype]);
                    return true;
                }
                function patchEvent(global, api) {
                    api.patchEventPrototype(global, api);
                }
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
                Zone.__load_patch('legacy', function (global) {
                    var legacyPatch = global[Zone.__symbol__('legacyPatch')];
                    if (legacyPatch) {
                        legacyPatch();
                    }
                });
                Zone.__load_patch('timers', function (global) {
                    var set = 'set';
                    var clear = 'clear';
                    patchTimer(global, set, clear, 'Timeout');
                    patchTimer(global, set, clear, 'Interval');
                    patchTimer(global, set, clear, 'Immediate');
                });
                Zone.__load_patch('requestAnimationFrame', function (global) {
                    patchTimer(global, 'request', 'cancel', 'AnimationFrame');
                    patchTimer(global, 'mozRequest', 'mozCancel', 'AnimationFrame');
                    patchTimer(global, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
                });
                Zone.__load_patch('blocking', function (global, Zone) {
                    var blockingMethods = ['alert', 'prompt', 'confirm'];
                    for (var i = 0; i < blockingMethods.length; i++) {
                        var name = blockingMethods[i];
                        patchMethod(global, name, function (delegate, symbol, name) {
                            return function (s, args) {
                                return Zone.current.run(delegate, global, args, name);
                            };
                        });
                    }
                });
                Zone.__load_patch('EventTarget', function (global, Zone, api) {
                    patchEvent(global, api);
                    eventTargetPatch(global, api);
                    // patch XMLHttpRequestEventTarget's addEventListener/removeEventListener
                    var XMLHttpRequestEventTarget = global['XMLHttpRequestEventTarget'];
                    if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) {
                        api.patchEventTarget(global, [XMLHttpRequestEventTarget.prototype]);
                    }
                    patchClass('MutationObserver');
                    patchClass('WebKitMutationObserver');
                    patchClass('IntersectionObserver');
                    patchClass('FileReader');
                });
                Zone.__load_patch('on_property', function (global, Zone, api) {
                    propertyDescriptorPatch(api, global);
                });
                Zone.__load_patch('customElements', function (global, Zone, api) {
                    patchCustomElements(global, api);
                });
                Zone.__load_patch('XHR', function (global, Zone) {
                    // Treat XMLHttpRequest as a macrotask.
                    patchXHR(global);
                    var XHR_TASK = zoneSymbol('xhrTask');
                    var XHR_SYNC = zoneSymbol('xhrSync');
                    var XHR_LISTENER = zoneSymbol('xhrListener');
                    var XHR_SCHEDULED = zoneSymbol('xhrScheduled');
                    var XHR_URL = zoneSymbol('xhrURL');
                    var XHR_ERROR_BEFORE_SCHEDULED = zoneSymbol('xhrErrorBeforeScheduled');
                    function patchXHR(window) {
                        var XMLHttpRequest = window['XMLHttpRequest'];
                        if (!XMLHttpRequest) {
                            // XMLHttpRequest is not available in service worker
                            return;
                        }
                        var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
                        function findPendingTask(target) { return target[XHR_TASK]; }
                        var oriAddListener = XMLHttpRequestPrototype[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                        var oriRemoveListener = XMLHttpRequestPrototype[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                        if (!oriAddListener) {
                            var XMLHttpRequestEventTarget = window['XMLHttpRequestEventTarget'];
                            if (XMLHttpRequestEventTarget) {
                                var XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget.prototype;
                                oriAddListener = XMLHttpRequestEventTargetPrototype[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                                oriRemoveListener = XMLHttpRequestEventTargetPrototype[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                            }
                        }
                        var READY_STATE_CHANGE = 'readystatechange';
                        var SCHEDULED = 'scheduled';
                        function scheduleTask(task) {
                            var data = task.data;
                            var target = data.target;
                            target[XHR_SCHEDULED] = false;
                            target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                            // remove existing event listener
                            var listener = target[XHR_LISTENER];
                            if (!oriAddListener) {
                                oriAddListener = target[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                                oriRemoveListener = target[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                            }
                            if (listener) {
                                oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                            }
                            var newListener = target[XHR_LISTENER] = function () {
                                if (target.readyState === target.DONE) {
                                    // sometimes on some browsers XMLHttpRequest will fire onreadystatechange with
                                    // readyState=4 multiple times, so we need to check task state here
                                    if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                                        // check whether the xhr has registered onload listener
                                        // if that is the case, the task should invoke after all
                                        // onload listeners finish.
                                        var loadTasks = target[Zone.__symbol__('loadfalse')];
                                        if (loadTasks && loadTasks.length > 0) {
                                            var oriInvoke_1 = task.invoke;
                                            task.invoke = function () {
                                                // need to load the tasks again, because in other
                                                // load listener, they may remove themselves
                                                var loadTasks = target[Zone.__symbol__('loadfalse')];
                                                for (var i = 0; i < loadTasks.length; i++) {
                                                    if (loadTasks[i] === task) {
                                                        loadTasks.splice(i, 1);
                                                    }
                                                }
                                                if (!data.aborted && task.state === SCHEDULED) {
                                                    oriInvoke_1.call(task);
                                                }
                                            };
                                            loadTasks.push(task);
                                        }
                                        else {
                                            task.invoke();
                                        }
                                    }
                                    else if (!data.aborted && target[XHR_SCHEDULED] === false) {
                                        // error occurs when xhr.send()
                                        target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                                    }
                                }
                            };
                            oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                            var storedTask = target[XHR_TASK];
                            if (!storedTask) {
                                target[XHR_TASK] = task;
                            }
                            sendNative.apply(target, data.args);
                            target[XHR_SCHEDULED] = true;
                            return task;
                        }
                        function placeholderCallback() { }
                        function clearTask(task) {
                            var data = task.data;
                            // Note - ideally, we would call data.target.removeEventListener here, but it's too late
                            // to prevent it from firing. So instead, we store info for the event listener.
                            data.aborted = true;
                            return abortNative.apply(data.target, data.args);
                        }
                        var openNative = patchMethod(XMLHttpRequestPrototype, 'open', function () { return function (self, args) {
                            self[XHR_SYNC] = args[2] == false;
                            self[XHR_URL] = args[1];
                            return openNative.apply(self, args);
                        }; });
                        var XMLHTTPREQUEST_SOURCE = 'XMLHttpRequest.send';
                        var fetchTaskAborting = zoneSymbol('fetchTaskAborting');
                        var fetchTaskScheduling = zoneSymbol('fetchTaskScheduling');
                        var sendNative = patchMethod(XMLHttpRequestPrototype, 'send', function () { return function (self, args) {
                            if (Zone.current[fetchTaskScheduling] === true) {
                                // a fetch is scheduling, so we are using xhr to polyfill fetch
                                // and because we already schedule macroTask for fetch, we should
                                // not schedule a macroTask for xhr again
                                return sendNative.apply(self, args);
                            }
                            if (self[XHR_SYNC]) {
                                // if the XHR is sync there is no task to schedule, just execute the code.
                                return sendNative.apply(self, args);
                            }
                            else {
                                var options = { target: self, url: self[XHR_URL], isPeriodic: false, args: args, aborted: false };
                                var task = scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                                if (self && self[XHR_ERROR_BEFORE_SCHEDULED] === true && !options.aborted &&
                                    task.state === SCHEDULED) {
                                    // xhr request throw error when send
                                    // we should invoke task instead of leaving a scheduled
                                    // pending macroTask
                                    task.invoke();
                                }
                            }
                        }; });
                        var abortNative = patchMethod(XMLHttpRequestPrototype, 'abort', function () { return function (self, args) {
                            var task = findPendingTask(self);
                            if (task && typeof task.type == 'string') {
                                // If the XHR has already completed, do nothing.
                                // If the XHR has already been aborted, do nothing.
                                // Fix #569, call abort multiple times before done will cause
                                // macroTask task count be negative number
                                if (task.cancelFn == null || (task.data && task.data.aborted)) {
                                    return;
                                }
                                task.zone.cancelTask(task);
                            }
                            else if (Zone.current[fetchTaskAborting] === true) {
                                // the abort is called from fetch polyfill, we need to call native abort of XHR.
                                return abortNative.apply(self, args);
                            }
                            // Otherwise, we are trying to abort an XHR which has not yet been sent, so there is no
                            // task
                            // to cancel. Do nothing.
                        }; });
                    }
                });
                Zone.__load_patch('geolocation', function (global) {
                    /// GEO_LOCATION
                    if (global['navigator'] && global['navigator'].geolocation) {
                        patchPrototype(global['navigator'].geolocation, ['getCurrentPosition', 'watchPosition']);
                    }
                });
                Zone.__load_patch('PromiseRejectionEvent', function (global, Zone) {
                    // handle unhandled promise rejection
                    function findPromiseRejectionHandler(evtName) {
                        return function (e) {
                            var eventTasks = findEventTasks(global, evtName);
                            eventTasks.forEach(function (eventTask) {
                                // windows has added unhandledrejection event listener
                                // trigger the event listener
                                var PromiseRejectionEvent = global['PromiseRejectionEvent'];
                                if (PromiseRejectionEvent) {
                                    var evt = new PromiseRejectionEvent(evtName, { promise: e.promise, reason: e.rejection });
                                    eventTask.invoke(evt);
                                }
                            });
                        };
                    }
                    if (global['PromiseRejectionEvent']) {
                        Zone[zoneSymbol('unhandledPromiseRejectionHandler')] =
                            findPromiseRejectionHandler('unhandledrejection');
                        Zone[zoneSymbol('rejectionHandledHandler')] =
                            findPromiseRejectionHandler('rejectionhandled');
                    }
                });
                /**
                 * @license
                 * Copyright Google Inc. All Rights Reserved.
                 *
                 * Use of this source code is governed by an MIT-style license that can be
                 * found in the LICENSE file at https://angular.io/license
                 */
            }));
            /***/ 
        }),
        /***/ "./src/polyfills.ts": 
        /*!**************************!*\
          !*** ./src/polyfills.ts ***!
          \**************************/
        /*! no exports provided */
        /***/ (function (module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
            /* harmony import */ var zone_js_dist_zone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! zone.js/dist/zone */ "./node_modules/zone.js/dist/zone-evergreen.js");
            /* harmony import */ var zone_js_dist_zone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(zone_js_dist_zone__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _webcomponents_webcomponentsjs_custom_elements_es5_adapter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @webcomponents/webcomponentsjs/custom-elements-es5-adapter.js */ "./node_modules/@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js");
            /* harmony import */ var _webcomponents_webcomponentsjs_custom_elements_es5_adapter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_webcomponents_webcomponentsjs_custom_elements_es5_adapter_js__WEBPACK_IMPORTED_MODULE_2__);
            /**
             * This file includes polyfills needed by Angular and is loaded before the app.
             * You can add your own extra polyfills to this file.
             *
             * This file is divided into 2 sections:
             *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
             *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
             *      file.
             *
             * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
             * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
             * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
             *
             * Learn more in https://angular.io/guide/browser-support
             */
            /***************************************************************************************************
             * BROWSER POLYFILLS
             */
            /** IE10 and IE11 requires the following for NgClass support on SVG elements */
            // import 'classlist.js';  // Run `npm install --save classlist.js`.
            /**
             * Web Animations `@angular/platform-browser/animations`
             * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
             * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
             */
            // import 'web-animations-js';  // Run `npm install --save web-animations-js`.
            /**
             * By default, zone.js will patch all possible macroTask and DomEvents
             * user can disable parts of macroTask/DomEvents patch by setting following flags
             * because those flags need to be set before `zone.js` being loaded, and webpack
             * will put import in the top of bundle, so user need to create a separate file
             * in this directory (for example: zone-flags.ts), and put the following flags
             * into that file, and then add the following code before importing zone.js.
             * import './zone-flags.ts';
             *
             * The flags allowed in zone-flags.ts are listed here.
             *
             * The following flags will work for all browsers.
             *
             * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
             * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
             * (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
             *
             *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
             *  with the following flag, it will bypass `zone.js` patch for IE/Edge
             *
             *  (window as any).__Zone_enable_cross_context_check = true;
             *
             */
            /***************************************************************************************************
             * Zone JS is required by default for Angular itself.
             */
            // Included with Angular CLI.
            /***************************************************************************************************
             * APPLICATION IMPORTS
             */
            /***/ 
        }),
        /***/ 1: 
        /*!***************************************************************************************************************************!*\
          !*** multi ./src/polyfills.ts ./node_modules/@angular-devkit/build-angular/src/angular-cli-files/models/jit-polyfills.js ***!
          \***************************************************************************************************************************/
        /*! no static exports found */
        /***/ (function (module, exports, __webpack_require__) {
            __webpack_require__(/*! /Users/development/Development/90tech/nt-planning/src/polyfills.ts */ "./src/polyfills.ts");
            module.exports = __webpack_require__(/*! /Users/development/Development/90tech/nt-planning/node_modules/@angular-devkit/build-angular/src/angular-cli-files/models/jit-polyfills.js */ "./node_modules/@angular-devkit/build-angular/src/angular-cli-files/models/jit-polyfills.js");
            /***/ 
        })
    }, [[1, "runtime"]]]);
//# sourceMappingURL=polyfills.js.map
//# sourceMappingURL=polyfills.js.map
//# sourceMappingURL=polyfills.js.map